/* Ardor Canvas Print Builder: options, live price, picture layout with the edge band, 3D preview, proof approval, cart and quote. Ardor Printing.
New Oct 9, 2026. Started as a copy of ardor-aframe-builder-v2.js (unchanged). Loaded by sections/ardor-canvas-builder-ws.liquid.
Sizes and prices are the canvas product's own Size variants (config JSON); the chosen variant goes in the cart.
Second style, added Oct 9, 2026: the floating frame. It is sold from its own hidden product (config "frame": one variant for
every size and frame color). Without "frame" in the config the builder offers the gallery wrap only, as before.
Works with ardor-canvas-layers.js (text and clipart), ardor-canvas3d.js (3D view) and ardor-canvas-pdf.js (proof and print PDFs).
v3 (Oct 19, 2026, wall art): copy of ardor-canvas-builder-v2.js (unchanged) with three more products in the Style list:
Acrylic print (Full White Backing, Spot White Backing or Transparent, custom size, drill holes and stand offs, round
corners), Framed print (3 sizes, wood frame) and Canvas roll (custom size, ships rolled). Loaded by
sections/ardor-canvas-builder-ws-v3-wall.liquid with ardor-canvas3d-v2.js and ardor-canvas-app-v2.js. */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__abb) return;
  root.__abb = true;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var CONF = {};
  try { CONF = JSON.parse($('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  if (!Array.isArray(CONF.sizes)) CONF.sizes = [];
  var PHONE = CONF.phone || '(425) 629-0796';

  // ---------- sizes, edges and prices ----------
// Sizes are the product's own Size variants (id, title such as 8" x 10", price in cents), written into the config by the section.
// FALLBACK holds the same sizes and prices so a price always shows. Prices are changed in Shopify on the variant.
var FALLBACK = [[8, 10, 7028], [11, 14, 7453], [12, 12, 7453], [12, 16, 7738], [12, 18, 7860], [16, 16, 8078], [16, 20, 8335], [16, 24, 8738], [18, 24, 8898], [24, 24, 9333], [24, 36, 11158], [32, 48, 19513]];
function sizeKey(w, h) { return Math.min(w, h) + 'x' + Math.max(w, h); }
function fallbackCents(w, h) { var k = sizeKey(w, h); for (var i = 0; i < FALLBACK.length; i++) if (sizeKey(FALLBACK[i][0], FALLBACK[i][1]) === k) return FALLBACK[i][2]; return 0; }
var SIZES = [];
CONF.sizes.forEach(function (v) {
  var m = /(\d+(?:\.\d+)?)\D+?(\d+(?:\.\d+)?)/.exec(String((v && v.title) || ''));
  if (!m) return;
  var a = parseFloat(m[1]), b = parseFloat(m[2]);
  if (!(a > 0 && b > 0)) return;
  var w = Math.min(a, b), h = Math.max(a, b), p = Math.round(Number(v.price));
  SIZES.push({ key: sizeKey(w, h), w: w, h: h, id: v.id || null, cents: isFinite(p) && p > 0 ? p : fallbackCents(w, h), available: v.available !== false });
});
if (!SIZES.length) FALLBACK.forEach(function (f) { SIZES.push({ key: sizeKey(f[0], f[1]), w: f[0], h: f[1], id: null, cents: f[2], available: true }); });

var DEPTH = 1.5; // inches: how deep the stretcher frame is = the edge band that folds around it
var BLEED = 1.75; // inches added on every side of the print file for Image wrap
var SAFE = 0.5; // inches from the edge of the face to the dashed red safe line
var MAX_QTY = 100;
var MAX_FILE = 25 * 1024 * 1024;
var EDGES = [
  { id: 'mirror', name: 'Mirrored edge', note: 'Your whole picture stays on the front. The sides show a mirror image of its outer 1.5 in.' },
  { id: 'wrap', name: 'Image wrap', note: 'Your picture continues around the sides, so the outer 1.5 in on each side is not on the front. Keep faces and text well inside the dashed line.' },
  { id: 'black', name: 'Black edge', note: 'Your whole picture stays on the front. The sides are solid black.' },
  { id: 'white', name: 'White edge', note: 'Your whole picture stays on the front. The sides are solid white.' }
].filter(function (e) { return e.id !== 'wrap' || CONF.imageWrap !== false; });
var WRAP_MSG = 'Make your picture bigger so it covers the edges, or choose Mirrored edge.';
var wrapErr = false; // Add to cart was stopped because the picture does not cover the edges

// ---------- floating frame (the second style) ----------
// The picture is printed on canvas at the exact size ordered, mounted flat and set in a floating frame: no edge band,
// no fold, no bleed. It is sold from its own hidden product, one variant for every size and frame color; the section
// writes those variants into the config (frame.variants: id, size, frame, price in cents, available).
// FRAME_FALLBACK holds the same sizes and prices so a price always shows. Prices are changed in Shopify on the variant.
var FRAME_FALLBACK = [[16, 16, 10294], [16, 24, 11158], [24, 24, 12025], [24, 36, 14036]];
var FRAME_DEPTH = 1.25; // inches: how deep the floating frame is
var FRAME_GAP = 0.25;   // inches: the gap between the picture and the frame
var FRAME_FACE = 0.25;  // inches: how wide the frame is, seen from the front
var FRAME_COLORS = [
  { id: 'pecan', name: 'Pecan', hex: '#9A6842' },
  { id: 'black', name: 'Black', hex: '#1B1B1D' },
  { id: 'white', name: 'White', hex: '#F6F4EE' }
];
var STYLES = [
  { id: 'wrap', name: 'Gallery wrap', note: 'Canvas hand-wrapped on a 1.5 in deep stretcher frame. You choose how the sides look.' },
  { id: 'frame', name: 'Floating frame', note: 'Canvas mounted flat on a rigid backer and set in a 1.25 in deep floating frame, with a narrow gap between the picture and the frame.' },
  { id: 'acrylic', name: 'Acrylic print', note: 'Your picture printed on the back of 1/4 in clear acrylic, in any size from 6 x 6 in to 48 x 38 in, with stand offs or drilled holes and square or round corners.' },
  { id: 'print', name: 'Framed print', note: 'Your picture printed on rigid foam board and set in a natural wood style frame, ready to hang. Three sizes.' },
  { id: 'roll', name: 'Canvas roll', note: 'Your picture printed on 15 mil artist canvas and shipped rolled, not stretched: ready to frame or stretch. Any size up to 58 in on the short side.' }
];
function frameFallbackCents(w, h) { var k = sizeKey(w, h); for (var i = 0; i < FRAME_FALLBACK.length; i++) if (sizeKey(FRAME_FALLBACK[i][0], FRAME_FALLBACK[i][1]) === k) return FRAME_FALLBACK[i][2]; return 0; }
var FSIZES = [], FCOLORS = [];
((CONF.frame && Array.isArray(CONF.frame.variants)) ? CONF.frame.variants : []).forEach(function (v) {
  var m = /(\d+(?:\.\d+)?)\D+?(\d+(?:\.\d+)?)/.exec(String((v && v.size) || ''));
  var col = String((v && v.frame) || '').toLowerCase().replace(/\s+/g, '');
  var known = FRAME_COLORS.filter(function (f) { return f.id === col; })[0];
  if (!m || !known) return;
  var a = parseFloat(m[1]), b = parseFloat(m[2]);
  if (!(a > 0 && b > 0)) return;
  var w = Math.min(a, b), h = Math.max(a, b), key = sizeKey(w, h), p = Math.round(Number(v.price));
  var z = FSIZES.filter(function (x) { return x.key === key; })[0];
  if (!z) { z = { key: key, w: w, h: h, v: {} }; FSIZES.push(z); }
  z.v[known.id] = { id: v.id || null, cents: isFinite(p) && p > 0 ? p : frameFallbackCents(w, h), available: v.available !== false };
  if (FCOLORS.indexOf(known) < 0) FCOLORS.push(known);
});
var FRAME_ON = FSIZES.length > 0 && FCOLORS.length > 0; // false = gallery wrap only, exactly as before
var movedFrom = ''; // the gallery wrap size the customer had before the floating frame moved them to one of its sizes
var styleNote = ''; // one line that says so

// ---------- v3 (Oct 19 2026): wall art (acrylic prints, framed prints, canvas rolls) ----------
// Acrylic prints and canvas rolls are custom sizes (width x height in inches). Their price follows the same rule as the
// other supplier products: 2 x (supplier cost + cheapest ground shipping to the shop), rounded up to the whole dollar,
// and the cart line is the hidden whole-dollar price product's variant for that price (ids in CONF.wall.pricesUrl).
// Framed prints come in three sizes, sold from their own hidden product (CONF.wall.print.variants).
// The gallery wrap and the floating frame work exactly as before (their own variants and prices).
var WALL = CONF.wall || {};
var ACR = { rate: 15.99, minCost: 15.99, standoff: 2.99, minSide: 6, maxShort: 38, maxLong: 48, thick: 0.25, holeInset: 1.5, stand: 1, shipSmall: 19.49, shipLarge: 42.42 };
var ROLL = { rate: 3.63, minCost: 8, minSide: 6, maxShort: 58, maxLong: 1200, thick: 0.04, ship: [19.49, 20.17, 22.18, 42.42] };
var PRINT_FACE = 2.625; // inches: the frame seen from the front (a 16 x 20 in print is 21.25 x 25.25 in framed)
var PRINT_DEPTH = 1;    // inches: how far the frame stands off the wall
var PRINT_HEX = '#D9CCA7';
var WALL_MARGIN = 0.75; // inches of wall shown around acrylic prints and canvas rolls in the flat drawing
var ACR_TYPES = [
  { id: 'white', name: 'Full White Backing', label: 'Clear Acrylic - Full White Backing', note: 'Printed in full color on the back of 1/4 in clear acrylic, then backed with white for the brightest colors. The acrylic face protects the print and gives it a glossy look.' },
  { id: 'spot', name: 'Spot White Backing', label: 'Clear Acrylic - Spot White Backing', note: 'Full color plus white printed only behind your art, so everything else stays clear. Upload a PNG with a transparent background: its transparent areas stay clear.' },
  { id: 'clear', name: 'Transparent (no white)', label: 'Clear Acrylic - Transparent (no white)', note: 'Full color printed on clear acrylic with no white: white in your art stays clear and the colors look see-through.' }
];
var HWS = [
  { id: 'none', key: '0', name: 'None', n: 0, holes: '' },
  { id: 'so4', key: 'acrylic+standoff', name: '4 Corners Hole Punch + Stand off', n: 4, holes: 'c4', so: true },
  { id: 'so2t', key: 'acrylic+2standoff_top', name: 'Top Corners Hole Punch + Stand off', n: 2, holes: 't2', so: true },
  { id: 'so2c', key: 'acrylic+2standoff_center', name: 'Center Top and Bottom + Stand off', n: 2, holes: 'c2', so: true },
  { id: 'so6', key: 'acrylic+6standoff', name: '4 Corners & Center Top and Bottom + Stand off', n: 6, holes: 'c6', so: true },
  { id: 'h4', key: 'TL;TR;BL;BR', name: '4 Corners Hole Punch', n: 0, holes: 'c4' },
  { id: 'h2t', key: 'TL;TR', name: 'Top Corners Hole Punch', n: 0, holes: 't2' },
  { id: 'h2c', key: 'TC;BC', name: 'Center Top and Bottom Hole Punch', n: 0, holes: 'c2' },
  { id: 'h6', key: 'TL;TR;BL;BR;TC;BC', name: '4 Corners & Center Top and Bottom Hole Punch', n: 0, holes: 'c6' }
];
var CORNERS = [{ id: 'none', name: 'None', r: 0 }, { id: '1_4', name: '1/4"', r: 0.25 }, { id: '1_2', name: '1/2"', r: 0.5 }, { id: '3_4', name: '3/4"', r: 0.75 }, { id: '1', name: '1"', r: 1 }];
var QUICK = {
  acrylic: [[8, 10], [11, 14], [12, 12], [12, 18], [16, 20], [18, 24], [20, 30], [24, 24], [24, 36], [30, 40], [36, 48]],
  roll: [[8, 10], [11, 14], [12, 12], [12, 18], [16, 20], [18, 24], [20, 30], [24, 24], [24, 36], [30, 40], [36, 48], [40, 60], [48, 72], [58, 96]]
};
var PSIZES = [];
((WALL.print && Array.isArray(WALL.print.variants)) ? WALL.print.variants : []).forEach(function (v) {
  var m = /(\d+(?:\.\d+)?)\D+?(\d+(?:\.\d+)?)/.exec(String((v && v.size) || ''));
  if (!m) return;
  var a = parseFloat(m[1]), b = parseFloat(m[2]); if (!(a > 0 && b > 0)) return;
  var w = Math.min(a, b), h = Math.max(a, b), p = Math.round(Number(v.price)), key = sizeKey(w, h);
  if (PSIZES.some(function (z) { return z.key === key; })) return;
  PSIZES.push({ key: key, w: w, h: h, id: v.id || null, cents: isFinite(p) && p > 0 ? p : 0, available: v.available !== false });
});
var WALL_ON = { acrylic: !!WALL.acrylic, roll: !!WALL.roll, print: PSIZES.length > 0 };
var STYLES_ON = STYLES.filter(function (st) { return st.id === 'wrap' || (st.id === 'frame' ? FRAME_ON : !!WALL_ON[st.id]); });
function styleOn(id) { return STYLES_ON.some(function (st) { return st.id === id; }); }
function isCustomStyle(id) { return id === 'acrylic' || id === 'roll'; }
function acrById(id) { for (var i = 0; i < ACR_TYPES.length; i++) if (ACR_TYPES[i].id === id) return ACR_TYPES[i]; return ACR_TYPES[0]; }
function hwById(id) { for (var i = 0; i < HWS.length; i++) if (HWS[i].id === id) return HWS[i]; return HWS[1]; }
function cornerById(id) { for (var i = 0; i < CORNERS.length; i++) if (CORNERS[i].id === id) return CORNERS[i]; return CORNERS[0]; }
function psizeByKey(k) { for (var i = 0; i < PSIZES.length; i++) if (PSIZES[i].key === k) return PSIZES[i]; return PSIZES[0] || { key: '16x20', w: 16, h: 20, id: null, cents: 0, available: false }; }
function cents2(x) { return Math.round(x * 100) / 100; }
function wholeUp(x) { return Math.ceil(cents2(x) - 1e-9); }
function acrShip(W, H) { var a = Math.round(W), b = Math.round(H); return (Math.min(a, b) <= 24 && Math.max(a, b) <= 36) ? ACR.shipSmall : ACR.shipLarge; }
function rollShip(W, H) { var s = Math.min(W, H), ft = W * H / 144; if (s > 48) return ROLL.ship[3]; return ft <= 280 ? ROLL.ship[0] : (ft <= 300 ? ROLL.ship[1] : ROLL.ship[2]); }
function acrCost(W, H, hw) { return cents2(Math.max(ACR.minCost, cents2(W * H / 144 * ACR.rate)) + hwById(hw).n * ACR.standoff); }
function rollCost(W, H) { return cents2(Math.max(ROLL.minCost, cents2(W * H / 144 * ROLL.rate))); }
// Ardor price for one piece, in whole dollars: 2 x (supplier cost + cheapest ground shipping), rounded up
function wallUnit(kind, W, H, hw) { return kind === 'acrylic' ? wholeUp(2 * (acrCost(W, H, hw) + acrShip(W, H))) : wholeUp(2 * (rollCost(W, H) + rollShip(W, H))); }
function wallProblem(kind, W, H, hw) {
  var L = kind === 'acrylic' ? ACR : ROLL, s = Math.min(W, H), l = Math.max(W, H), nm = kind === 'acrylic' ? 'Acrylic prints' : 'Canvas rolls';
  if (!(W > 0 && H > 0)) return 'Type a width and a height in inches.';
  if (s < L.minSide) return nm + ' are at least ' + L.minSide + ' x ' + L.minSide + ' in.';
  if (s > L.maxShort || l > L.maxLong) return nm + ' go up to ' + L.maxShort + ' x ' + L.maxLong + ' in (either way). For a bigger size, request a quote.';
  var lim = WALL[kind] && WALL[kind].max;
  if (lim && wallUnit(kind, W, H, hw) > lim) return 'This size is bigger than we can order online. Please request a quote.';
  return '';
}
// where the holes go (inches from the top-left corner of the front): 1.5 in in from the edges
function acrHoles(hw, W, H) {
  var h = hwById(hw), e = ACR.holeInset, out = [];
  if (!h.holes) return out;
  var add = function (x, y) { out.push({ x: x, y: y, so: !!h.so }); };
  if (h.holes === 'c4' || h.holes === 'c6') { add(e, e); add(W - e, e); add(e, H - e); add(W - e, H - e); }
  if (h.holes === 't2') { add(e, e); add(W - e, e); }
  if (h.holes === 'c2' || h.holes === 'c6') { add(W / 2, e); add(W / 2, H - e); }
  return out;
}
function fitCustom(kind, W, H) {
  var L = kind === 'acrylic' ? ACR : ROLL, w = Math.max(L.minSide, W), h = Math.max(L.minSide, H), moved = (w !== W || h !== H);
  var s = Math.min(w, h), l = Math.max(w, h), k = Math.min(1, L.maxShort / s, L.maxLong / l);
  if (k < 1) { w = Math.floor(w * k); h = Math.floor(h * k); moved = true; }
  return { w: w, h: h, moved: moved };
}
function typeNoun(c) { return c.kind === 'acrylic' ? 'acrylic print' : (c.kind === 'roll' ? 'canvas roll' : (c.kind === 'print' ? 'framed print' : (c.framed ? 'framed canvas' : 'canvas'))); }
function wallTitle(c, what) { return c.kind === 'acrylic' ? 'Ardor Acrylic Print ' + what : (c.kind === 'roll' ? 'Ardor Canvas Roll ' + what : (c.kind === 'print' ? 'Ardor Framed Print ' + what : 'Ardor Canvas ' + what)); }
// the lowest price of a style, in cents (the style picker shows it)
function styleFrom(id) {
  var lo = 0, take = function (x) { if (x > 0 && (!lo || x < lo)) lo = x; };
  if (id === 'wrap') SIZES.forEach(function (z) { take(z.cents); });
  else if (id === 'frame') FSIZES.forEach(function (z) { for (var k in z.v) take(z.v[k].cents); });
  else if (id === 'print') PSIZES.forEach(function (z) { take(z.cents); });
  else if (id === 'acrylic') take(wallUnit('acrylic', ACR.minSide, ACR.minSide, 'none') * 100);
  else if (id === 'roll') take(wallUnit('roll', ROLL.minSide, ROLL.minSide) * 100);
  return lo;
}
function roundRectPath(ctx, x, y, w, h, r) {
  r = Math.max(0, Math.min(r || 0, w / 2, h / 2));
  ctx.beginPath();
  if (!r) { ctx.rect(x, y, w, h); return; }
  ctx.moveTo(x + r, y); ctx.lineTo(x + w - r, y); ctx.arcTo(x + w, y, x + w, y + r, r); ctx.lineTo(x + w, y + h - r); ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
  ctx.lineTo(x + r, y + h); ctx.arcTo(x, y + h, x, y + h - r, r); ctx.lineTo(x, y + r); ctx.arcTo(x, y, x + r, y, r); ctx.closePath();
}
// holes and stand off caps on a flat drawing (inches, origin at the top-left of the front). onlyHoles: skip the caps (3D draws them)
function drawHoles(ctx, c, onlyHoles) {
  (c.holes || []).forEach(function (h) {
    ctx.save();
    if (h.so && !onlyHoles) {
      var g = ctx.createRadialGradient(h.x - 0.15, h.y - 0.18, 0.05, h.x, h.y, 0.5);
      g.addColorStop(0, '#FBFBFB'); g.addColorStop(0.55, '#C9CCCF'); g.addColorStop(1, '#8E9296');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(h.x, h.y, 0.5, 0, Math.PI * 2); ctx.fill();
      ctx.lineWidth = 0.03; ctx.strokeStyle = 'rgba(40,42,45,0.55)'; ctx.stroke();
    } else if (!h.so) {
      ctx.fillStyle = '#6A6762'; ctx.beginPath(); ctx.arc(h.x, h.y, 0.1875, 0, Math.PI * 2); ctx.fill();
      ctx.lineWidth = 0.03; ctx.strokeStyle = 'rgba(255,255,255,0.8)'; ctx.stroke();
    }
    ctx.restore();
  });
}
function wallPlaceholder(ctx, Wi, Hi) {
  ctx.fillStyle = '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  ctx.font = '600 ' + Math.min(Hi * 0.08, Wi * 0.075) + 'px Arial, sans-serif';
  ctx.fillText('Your photo goes here', Wi / 2, Hi / 2);
}
// Flat drawing for the wall art types (2D editor and proof). Framed print: the picture in its wood frame. Acrylic print:
// the clear panel on the wall (rounded corners, holes or stand offs). Canvas roll: the flat sheet.
function drawFlatWall(ctx, c, k, guides, forEditor) {
  var Wi = c.Wi, Hi = c.Hi, B = c.margin, TW = Wi + 2 * B, TH = Hi + 2 * B;
  var any = !!ART.front || hasLayers(), fl = Math.max(TW, TH) / 1100;
  ctx.save();
  ctx.translate(B, B);
  if (c.printFrame) {
    ctx.fillStyle = c.frameHex; ctx.fillRect(-B, -B, TW, TH);
    var bv = Math.min(0.45, B * 0.18); // the lighter bevel next to the picture
    ctx.fillStyle = '#EFE8D2'; ctx.fillRect(-bv, -bv, Wi + 2 * bv, Hi + 2 * bv);
    if (any) paintArea(ctx, Wi, Hi, 0, forEditor); else { ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi); wallPlaceholder(ctx, Wi, Hi); }
    ctx.save();
    ctx.setLineDash([]); ctx.lineWidth = fl; ctx.strokeStyle = 'rgba(0,0,0,0.3)';
    ctx.strokeRect(-B + fl / 2, -B + fl / 2, TW - fl, TH - fl);
    ctx.beginPath();
    ctx.moveTo(-B, -B); ctx.lineTo(-bv, -bv); ctx.moveTo(Wi + B, -B); ctx.lineTo(Wi + bv, -bv);
    ctx.moveTo(-B, Hi + B); ctx.lineTo(-bv, Hi + bv); ctx.moveTo(Wi + B, Hi + B); ctx.lineTo(Wi + bv, Hi + bv);
    ctx.stroke();
    ctx.restore();
  } else {
    var acr = c.kind === 'acrylic', r = c.cornerIn || 0;
    ctx.fillStyle = '#E9E7E2'; ctx.fillRect(-B, -B, TW, TH); // the wall
    if (acr && c.standoff) { ctx.save(); ctx.shadowColor = 'rgba(0,0,0,0.22)'; ctx.shadowBlur = 0.6 * k; ctx.shadowOffsetX = 0.18 * k; ctx.shadowOffsetY = 0.25 * k; ctx.fillStyle = '#E9E7E2'; roundRectPath(ctx, 0, 0, Wi, Hi, r); ctx.fill(); ctx.restore(); }
    ctx.save();
    roundRectPath(ctx, 0, 0, Wi, Hi, r); ctx.clip();
    ctx.fillStyle = (acr && c.acr !== 'white') ? '#EEF1EF' : '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi); // clear acrylic shows the wall
    if (any) {
      if (acr && c.acr === 'clear') ctx.globalCompositeOperation = 'multiply'; // no white ink: white stays clear
      paintArea(ctx, Wi, Hi, 0, forEditor);
      ctx.globalCompositeOperation = 'source-over';
    } else wallPlaceholder(ctx, Wi, Hi);
    ctx.restore();
    ctx.save();
    ctx.setLineDash([]); ctx.lineWidth = acr ? Math.max(fl * 1.6, 0.06) : fl; ctx.strokeStyle = acr ? 'rgba(96,140,128,0.75)' : 'rgba(0,0,0,0.28)';
    roundRectPath(ctx, 0, 0, Wi, Hi, r); ctx.stroke();
    ctx.restore();
    if (acr) drawHoles(ctx, c, false);
  }
  if (guides) {
    var lw = Math.max(TW, TH) / 600;
    ctx.save();
    ctx.setLineDash([]); ctx.lineWidth = lw * 2.6; ctx.strokeStyle = 'rgba(255,255,255,0.7)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    ctx.setLineDash([lw * 6, lw * 4]); ctx.lineWidth = lw * 1.5; ctx.strokeStyle = 'rgba(189,37,44,0.95)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    ctx.setLineDash([]);
    ctx.restore();
  }
  ctx.restore();
}
// Transparent (no white) acrylic in 3D: white turns clear and the inks look see-through
function clearToAlpha(cv) {
  try {
    var ctx = cv.getContext('2d'), d = ctx.getImageData(0, 0, cv.width, cv.height), p = d.data;
    for (var i = 0; i < p.length; i += 4) {
      var mn = Math.min(p[i], p[i + 1], p[i + 2]), a = 1 - mn / 255;
      if (a <= 0.004) { p[i + 3] = 0; continue; }
      p[i] = Math.max(0, Math.min(255, (p[i] - 255 * (1 - a)) / a));
      p[i + 1] = Math.max(0, Math.min(255, (p[i + 1] - 255 * (1 - a)) / a));
      p[i + 2] = Math.max(0, Math.min(255, (p[i + 2] - 255 * (1 - a)) / a));
      p[i + 3] = Math.round(255 * a * 0.85 * (p[i + 3] / 255));
    }
    ctx.putImageData(d, 0, 0);
  } catch (e) {}
}
// Spot White Backing: the print file is a PNG with a transparent background (what production needs)
function spotPng(c) {
  var W = c.Wi, H = c.Hi, ppi = Math.max(20, Math.min(150, Math.sqrt(12e6 / (W * H))));
  var w = Math.max(1, Math.round(W * ppi)), h = Math.max(1, Math.round(H * ppi));
  var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
  var ctx = cv.getContext('2d'); if (!ctx) return Promise.reject(new Error('canvas'));
  ctx.setTransform(w / W, 0, 0, h / H, 0, 0);
  ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
  paintArea(ctx, W, H, 0, false);
  return new Promise(function (res, rej) { cv.toBlob(function (b) { cv.width = cv.height = 1; if (b) res({ blob: b, ppi: ppi, w: w, h: h }); else rej(new Error('png')); }, 'image/png'); });
}
var wallPrices = null;
function loadWallPrices() {
  if (wallPrices) return Promise.resolve(wallPrices);
  if (!WALL.pricesUrl) return Promise.reject(new Error(setupMsg()));
  return fetch(WALL.pricesUrl, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(setupMsg()); return r.json(); }).then(function (j) { wallPrices = j; return j; });
}
// the cart variant for a custom size: the hidden price product's variant for this whole-dollar price
function wallVid(c, p) {
  if (!c.custom) return Promise.resolve(p.vid);
  return loadWallPrices().then(function (tbl) {
    var t = tbl && tbl[c.kind], u = Math.round(p.unit);
    if (!t || !Array.isArray(t.ids) || u < t.min || u > t.max || !t.ids[u - t.min]) throw new Error('This size is bigger than we can order online. Please request a quote.');
    return t.ids[u - t.min];
  });
}
function pickAcr(id) { if (id === S.acr) return; set({ acr: id, artVer: S.artVer + 1 }); }
function pickHw(id) { if (id === S.hw) return; set({ hw: id, artVer: S.artVer + 1 }); }
function pickCorner(id) { if (id === S.corner) return; set({ corner: id, artVer: S.artVer + 1 }); }
function setCustom(w, h) { w = Math.round(num(w, S.cw) * 100) / 100; h = Math.round(num(h, S.ch) * 100) / 100; if (w === S.cw && h === S.ch) return; S.cw = w; S.ch = h; refit(); set({ artVer: S.artVer + 1 }); }
// the quick sizes for an acrylic print or a canvas roll, each with its price, plus the size the customer typed
function renderCustomSizes(c) {
  var list = QUICK[c.kind] || [], W = c.Wi, H = c.Hi, land = W > H;
  var same = function (q) { return Math.abs(Math.min(q[0], q[1]) - Math.min(W, H)) < 1e-6 && Math.abs(Math.max(q[0], q[1]) - Math.max(W, H)) < 1e-6; };
  var nodes = [];
  if (!list.some(same)) nodes.push(optBtn({ on: true, data: ['csize', 'custom'], html: '<span class="abb-opt__name">' + esc(fmt(W) + ' x ' + fmt(H) + ' in') + '</span><span class="abb-opt__price">' + esc(c.problem ? 'Not available online' : money(c.size.cents / 100)) + '</span>', pick: function () {} }));
  list.forEach(function (q) {
    var w = land ? Math.max(q[0], q[1]) : Math.min(q[0], q[1]), h = land ? Math.min(q[0], q[1]) : Math.max(q[0], q[1]);
    var u = wallUnit(c.kind, w, h, c.hw), bad = wallProblem(c.kind, w, h, c.hw);
    nodes.push(optBtn({ on: same(q), disabled: !!bad, data: ['csize', Math.min(q[0], q[1]) + 'x' + Math.max(q[0], q[1])], html: '<span class="abb-opt__name">' + esc(fmt(w) + ' x ' + fmt(h) + ' in') + '</span><span class="abb-opt__price">' + money(u) + '</span>', pick: function () { setCustom(w, h); } }));
  });
  fill($('[data-abb-sizes]'), nodes);
  var wI = $('[data-abb-w]'), hI = $('[data-abb-h]'), L = c.kind === 'acrylic' ? ACR : ROLL;
  if (wI && document.activeElement !== wI) wI.value = fmt(W);
  if (hI && document.activeElement !== hI) hI.value = fmt(H);
  [wI, hI].forEach(function (x) { if (x) { x.min = String(L.minSide); x.max = String(L.maxLong); } });
  var note = $('[data-abb-csize-note]');
  if (note) {
    note.textContent = c.problem || (c.kind === 'acrylic' ? 'Type any size from 6 x 6 in to 48 x 38 in (either way), or pick one below. Prices include shipping.' : 'Type any size from 6 x 6 in, up to 58 in on the short side, or pick one below. Ships rolled. Prices include shipping.');
    if (c.problem) note.setAttribute('data-level', 'bad'); else note.removeAttribute('data-level');
  }
}
function renderWallRows(c) {
  var acr = c.kind === 'acrylic', roll = c.kind === 'roll';
  var mw = $('[data-abb-mat-wrap]'), hw = $('[data-abb-hw-wrap]'), cw = $('[data-abb-corner-wrap]'), cs = $('[data-abb-csize]');
  if (mw) mw.hidden = !(acr || roll);
  if (hw) hw.hidden = !acr;
  if (cw) cw.hidden = !acr;
  if (cs) cs.hidden = !c.custom;
  var mt = acr ? 'Acrylic type' : 'Material';
  setText('[data-abb-mat-title]', mt);
  var rl = root.querySelector('.abx-row[data-abx-row="mat"] .abx-row__label'); if (rl) rl.textContent = mt;
  var ft = c.printFrame ? 'Frame' : 'Frame color';
  setText('[data-abb-frame-title]', ft);
  var fl = root.querySelector('.abx-row[data-abx-row="frame"] .abx-row__label'); if (fl) fl.textContent = ft;
  if (acr) {
    fill($('[data-abb-mats]'), ACR_TYPES.map(function (t) { return optBtn({ chip: true, on: c.acr === t.id, data: ['acr', t.id], label: t.name, pick: function () { pickAcr(t.id); } }); }));
    setText('[data-abb-mat-note]', acrById(c.acr).note + ' All three cost the same.');
    var base = wallUnit('acrylic', c.Wi, c.Hi, 'none');
    fill($('[data-abb-hws]'), HWS.map(function (h) {
      var add = wallUnit('acrylic', c.Wi, c.Hi, h.id) - base;
      return optBtn({ on: c.hw === h.id, data: ['hw', h.id], html: '<span class="abb-opt__name">' + esc(h.name) + '</span><span class="abb-opt__price">' + (add > 0 ? '+' + money(add) : 'Included') + '</span>', pick: function () { pickHw(h.id); } });
    }));
    var hh = hwById(c.hw);
    setText('[data-abb-hw-note]', hh.so ? 'Chrome stand offs (1 in across) hold your print 1 in off the wall. The holes are 1.5 in in from the edges. Mounting screws included.' : (hh.holes ? '3/8 in holes drilled 1.5 in in from the edges, for your own screws or hooks.' : 'No holes. Hang it with your own hardware, or stand it on a shelf or easel.'));
    fill($('[data-abb-corners]'), CORNERS.map(function (k) { return optBtn({ chip: true, on: c.corner === k.id, data: ['corner', k.id], label: k.name, pick: function () { pickCorner(k.id); } }); }));
    setText('[data-abb-corner-note]', 'Round corners do not change the price.');
  } else if (roll) {
    fill($('[data-abb-mats]'), [optBtn({ chip: true, on: true, data: ['mat', '15mil'], label: '15mil. White Canvas', pick: function () {} })]);
    setText('[data-abb-mat-note]', '15 mil white semigloss artist canvas (poly-cotton), printed on one side. Not stretched: it ships rolled, ready to frame or stretch on bars.');
  }
}
function wallNote(c) {
  if (c.kind === 'acrylic') return 'Acrylic print, ' + c.acrLabel + ', ' + sizeLabel(c) + ', 1/4 in clear acrylic printed on the back. Drill Holes & Stand off: ' + c.hwName + (c.holes.length ? ' (holes 1.5 in in from the edges)' : '') + '. Round Corners: ' + c.cornerName + '.';
  if (c.kind === 'roll') return 'Canvas roll, 15mil. White Canvas, ' + sizeLabel(c) + ', not stretched, ship rolled.';
  if (c.kind === 'print') return 'Framed print, ' + sizeLabel(c) + ' graphic, ' + orientFull(c) + ', natural wood style frame.';
  return '';
}
function spotWarn(c, a) {
  if (c.kind !== 'acrylic' || c.acr !== 'spot' || !a || !a.file) return '';
  if (/png$/i.test(a.file.type || '') || /\.png$/i.test(a.name || '')) return '';
  return 'Spot White Backing prints white only behind the art in a PNG with a transparent background. This file is not a PNG, so its whole background prints. Upload a PNG with a transparent background, or choose Full White Backing.';
}

var S = { size: SIZES[0].key, orient: 'portrait', edge: 'mirror', style: 'wrap', frame: FCOLORS.length ? FCOLORS[0].id : 'pecan', qty: 1, delivery: '', artVer: 0, acr: 'white', hw: 'so4', corner: 'none', cw: 12, ch: 12, psize: PSIZES.length ? PSIZES[0].key : '16x20' };
var ART = { front: null };
var eng = null;

function sizeByKey(k) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i].key === k) return SIZES[i]; return SIZES[0]; }
function edgeById(id) { for (var i = 0; i < EDGES.length; i++) if (EDGES[i].id === id) return EDGES[i]; return EDGES[0]; }
function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }

// c.Wi x c.Hi is the face (the front of the canvas) in inches, already turned for the orientation
function hasSize(k) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i].key === k) return true; return false; }
function fsizeByKey(k) { for (var i = 0; i < FSIZES.length; i++) if (FSIZES[i].key === k) return FSIZES[i]; return null; }
function frameDefault() { return fsizeByKey('16x24') || FSIZES[0]; }
function frameById(id) { for (var i = 0; i < FCOLORS.length; i++) if (FCOLORS[i].id === id) return FCOLORS[i]; return FCOLORS[0]; }
function styleById(id) { for (var i = 0; i < STYLES.length; i++) if (STYLES[i].id === id) return STYLES[i]; return STYLES[0]; }
// the variant of a framed size in one frame color
function frameVariant(z, id) { return z.v[id] || { id: null, cents: frameFallbackCents(z.w, z.h), available: false }; }
function sizeText(z) { return fmt(z.w) + ' x ' + fmt(z.h) + ' in'; }

// c.style is 'wrap' (gallery wrap) or 'frame' (floating frame). For the floating frame c.size is the framed size with the
// variant id and price of the chosen frame color, there is no edge style (c.edge is 'none'), and c.Wi x c.Hi is the picture.
// c.depth = how deep it is on the wall; c.margin = what the flat drawing shows around the face on every side
// (the 1.5 in edge band of a gallery wrap, or the gap plus the frame of a floating frame).
function cfg(over) {
  var s = Object.assign({}, S, over || {});
  var st = styleOn(s.style) ? s.style : 'wrap';
  var base = { kind: st, custom: false, printFrame: false, acr: '', acrName: '', acrLabel: '', hw: '', hwName: '', corner: '', cornerName: '', cornerIn: 0, holes: [], standoff: 0, problem: '', material: '',
    qty: Math.max(1, Math.min(MAX_QTY, Math.round(num(s.qty, 1)))), artVer: s.artVer };
  if (isCustomStyle(st)) {
    // acrylic print or canvas roll: any width x height, typed in inches (c.Wi x c.Hi as it hangs)
    var W = Math.max(0, num(s.cw, 0)), H = Math.max(0, num(s.ch, 0)), isA = st === 'acrylic';
    var at = acrById(s.acr), hw = hwById(s.hw), co = cornerById(s.corner);
    var prob = wallProblem(st, W, H, hw.id), unit = (W > 0 && H > 0) ? wallUnit(st, W, H, hw.id) : 0;
    return Object.assign(base, {
      size: { key: 'custom', w: Math.min(W, H), h: Math.max(W, H), id: null, cents: unit * 100, available: !prob },
      square: W === H, orient: W === H ? 'square' : (W > H ? 'landscape' : 'portrait'),
      style: st, custom: true, framed: false, styleName: styleById(st).name,
      frame: '', frameName: '', frameHex: '', edge: 'none', edgeName: '', wrap: false,
      depth: isA ? ACR.thick : ROLL.thick, margin: WALL_MARGIN, Wi: W, Hi: H,
      acr: isA ? at.id : '', acrName: isA ? at.name : '', acrLabel: isA ? at.label : '',
      hw: isA ? hw.id : '', hwName: isA ? hw.name : '', corner: isA ? co.id : '', cornerName: isA ? co.name : '', cornerIn: isA ? co.r : 0,
      holes: isA && W > 0 && H > 0 ? acrHoles(hw.id, W, H) : [], standoff: isA && hw.so ? ACR.stand : 0, problem: prob,
      material: isA ? '' : '15mil. White Canvas'
    });
  }
  if (st === 'print') {
    // framed print: one of the sizes of its hidden product, portrait or landscape, in a wood frame
    var pz = psizeByKey(s.psize), psq = pz.w === pz.h, po = psq ? 'square' : (s.orient === 'landscape' ? 'landscape' : 'portrait');
    return Object.assign(base, {
      size: { key: pz.key, w: pz.w, h: pz.h, id: pz.id, cents: pz.cents, available: pz.available },
      square: psq, orient: po, style: 'print', printFrame: true, framed: false, styleName: styleById('print').name,
      frame: 'wood', frameName: 'Wood', frameHex: PRINT_HEX, edge: 'none', edgeName: '', wrap: false,
      depth: PRINT_DEPTH, margin: PRINT_FACE, Wi: po === 'landscape' ? pz.h : pz.w, Hi: po === 'landscape' ? pz.w : pz.h
    });
  }
  var framed = FRAME_ON && st === 'frame';
  var z, fr = null;
  if (framed) {
    var fz = fsizeByKey(s.size) || frameDefault(), fv;
    fr = frameById(s.frame); fv = frameVariant(fz, fr.id);
    z = { key: fz.key, w: fz.w, h: fz.h, id: fv.id, cents: fv.cents, available: fv.available };
  } else z = sizeByKey(s.size);
  var square = z.w === z.h;
  var orient = square ? 'square' : (s.orient === 'landscape' ? 'landscape' : 'portrait');
  var e = edgeById(s.edge);
  return Object.assign(base, {
    kind: framed ? 'frame' : 'wrap',
    size: z, square: square, orient: orient,
    style: framed ? 'frame' : 'wrap', framed: framed, styleName: styleById(framed ? 'frame' : 'wrap').name,
    frame: framed ? fr.id : '', frameName: framed ? fr.name : '', frameHex: framed ? fr.hex : '',
    edge: framed ? 'none' : e.id, edgeName: framed ? '' : e.name, wrap: !framed && e.id === 'wrap',
    depth: framed ? FRAME_DEPTH : DEPTH, margin: framed ? FRAME_GAP + FRAME_FACE : DEPTH,
    Wi: orient === 'landscape' ? z.h : z.w, Hi: orient === 'landscape' ? z.w : z.h
  });
}
function price(c) { var unit = c.size.cents; return { unit: unit / 100, charged: unit * c.qty / 100, vid: c.size.id, disc: 0 }; }

function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmt(n) { var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < 0.001 ? String(Math.round(r)) : String(r); }

  // ---------- labels ----------
function sizeLabel(c) { return c.custom ? fmt(c.Wi) + ' x ' + fmt(c.Hi) + ' in (width x height)' : fmt(c.size.w) + ' x ' + fmt(c.size.h) + ' in'; } // the size as sold (short side first; custom sizes as typed)
function faceLabel(c) { return fmt(c.Wi) + ' x ' + fmt(c.Hi) + ' in'; } // width x height as it hangs
function orientLabel(c) { return c.orient === 'square' ? 'Square' : (c.orient === 'landscape' ? 'Landscape' : 'Portrait'); }
function orientFull(c) { return c.orient === 'square' ? 'Square' : orientLabel(c) + ' (' + fmt(c.Wi) + ' in wide x ' + fmt(c.Hi) + ' in tall)'; }
function shipLabel() { return CONF.shipLabel || 'Ship it to me'; }
function deliveryLabel() { return S.delivery === 'pickup' ? 'Pick up in Snohomish (free)' : shipLabel(); }

// ---------- option buttons ----------
  function optBtn(opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'abb-opt' + (opts.chip ? ' abb-opt--chip' : '');
    b.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
    if (opts.data) b.setAttribute('data-' + opts.data[0], String(opts.data[1]));
    if (opts.disabled) b.disabled = true;
    if (opts.html) b.innerHTML = opts.html; else b.textContent = opts.label;
    b.addEventListener('click', opts.pick);
    return b;
  }
  function fill(el, nodes) {
    if (!el) return;
    var ae = document.activeElement, idx = -1;
    if (ae && el.contains(ae)) idx = Array.prototype.indexOf.call(el.children, ae);
    el.textContent = '';
    nodes.forEach(function (n) { el.appendChild(n); });
    if (idx >= 0 && el.children[idx]) { try { el.children[idx].focus({ preventScroll: true }); } catch (e) {} }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function set(patch) { Object.assign(S, patch); render(); }
  function setText(sel, t) { var el = $(sel); if (el) el.textContent = t; }

  // a new size or orientation: keep the picture, but fit it to the new shape
function refit() { var a = ART.front; if (a) { a.mode = a.kind === 'image' ? 'fill' : 'fit'; a.rcx = 0.5; a.rcy = 0.5; } }
function pickSize(key) { if (cfg().printFrame) { if (key === S.psize) return; styleNote = ''; refit(); set({ psize: key, artVer: S.artVer + 1 }); return; } if (key === S.size) return; movedFrom = ''; styleNote = ''; refit(); set({ size: key, artVer: S.artVer + 1 }); }
function pickOrient(o) { if (o === cfg().orient) return; refit(); set({ orient: o, artVer: S.artVer + 1 }); }
function pickEdge(id) {
  if (id === cfg().edge) return;
  S.edge = id;
  // Image wrap needs the picture to cover the edges too: start from Fill when it does not
  var c = cfg(), a = ART.front;
  if (c.wrap && a && a.img && !coversWrap(a, c)) { a.mode = 'fill'; a.rcx = 0.5; a.rcy = 0.5; }
  set({ artVer: S.artVer + 1 });
}
// Gallery wrap or floating frame. The floating frame has its own, shorter list of sizes: a size it does not have moves
// to 16 x 24 (and a line under the switch says so); going back to the gallery wrap brings the old size back.
function pickStyle(id) {
  var cur = cfg();
  if (!styleOn(id) || id === cur.style) return;
  var a = ART.front;
  styleNote = '';
  if (isCustomStyle(id)) {
    // acrylic print or canvas roll: keep the size the customer had, inside the new product's limits
    var f = fitCustom(id, cur.Wi, cur.Hi);
    S.cw = f.w; S.ch = f.h;
    if (f.moved) styleNote = styleById(id).name + 's come in ' + (id === 'acrylic' ? '6 x 6 in to 48 x 38 in' : '6 x 6 in and up, to 58 in on the short side') + ', so your size changed from ' + fmt(cur.Wi) + ' x ' + fmt(cur.Hi) + ' in to ' + fmt(f.w) + ' x ' + fmt(f.h) + ' in.';
  } else if (id === 'print') {
    // framed prints: the closest of their sizes
    var best = null, d = 1e12;
    PSIZES.forEach(function (z) { var dd = Math.abs(z.w * z.h - cur.size.w * cur.size.h) + 400 * Math.abs(z.w / z.h - cur.size.w / cur.size.h); if (dd < d) { d = dd; best = z; } });
    if (best) {
      if (!(best.w === cur.size.w && best.h === cur.size.h)) styleNote = 'Framed prints come in ' + PSIZES.length + ' sizes, so your size changed from ' + fmt(cur.Wi) + ' x ' + fmt(cur.Hi) + ' in to ' + sizeText(best) + '.';
      S.psize = best.key;
    }
    if (cur.orient !== 'square') S.orient = cur.orient;
  } else if (id === 'frame') {
    if (fsizeByKey(S.size)) movedFrom = '';
    else {
      var dfz = frameDefault();
      movedFrom = S.size; S.size = dfz.key;
      styleNote = 'Floating frames come in ' + FSIZES.length + ' sizes, so your size changed from ' + sizeText(sizeByKey(movedFrom)) + ' to ' + sizeText(dfz) + '.';
    }
    if (cur.custom && cur.orient !== 'square') S.orient = cur.orient;
  } else {
    if (movedFrom && hasSize(movedFrom)) S.size = movedFrom;
    else if (!hasSize(S.size)) S.size = SIZES[0].key;
    movedFrom = '';
    if (cur.custom && cur.orient !== 'square') S.orient = cur.orient;
  }
  S.style = id;
  var c = cfg();
  if (c.Wi !== cur.Wi || c.Hi !== cur.Hi) refit();
  // back on Image wrap, the picture has to cover the edges again
  if (c.wrap && a && a.img && !coversWrap(a, c)) { a.mode = 'fill'; a.rcx = 0.5; a.rcy = 0.5; }
  set({ artVer: S.artVer + 1 });
}
function pickFrame(id) { if (id === S.frame) return; set({ frame: id }); }
// a new picture: turn the canvas to match it (landscape picture = landscape canvas)
function autoOrient(a) {
  var c = cfg(); if (!a || !(a.natW > 0 && a.natH > 0)) return;
  var r = a.natW / a.natH;
  if (c.custom) { if ((r > 1.05 && S.cw < S.ch) || (r < 0.95 && S.cw > S.ch)) { var t = S.cw; S.cw = S.ch; S.ch = t; } return; }
  if (c.square) return;
  if (r > 1.05) S.orient = 'landscape'; else if (r < 0.95) S.orient = 'portrait';
}

// ---------- artwork ----------
function hasLayers() { return !!(window.ArdorCanvasLayers && window.ArdorCanvasLayers.has('front')); } // text and clipart added in the builder (ardor-canvas-layers.js)
var LAYER_NOTE = 'Print file made from a flattened image of the artwork plus text and clipart added in the builder.';
function layerSummary() {
  var LY = window.ArdorCanvasLayers; if (!LY || !LY.list) return '';
  return (LY.list('front') || []).map(function (o) { return o.kind === 'text' ? '"' + String(o.text || '').replace(/\s+/g, ' ').trim() + '"' + (o.font ? ' (' + o.font + ')' : '') : (o.label || o.kind); }).join(', ');
}

// How wide the picture must be to cover everything that prints: the face, plus the bleed on every side for Image wrap.
function fillWidth(ia, Wi, Hi) { var b = cfg().wrap ? BLEED : 0; return Math.max(Wi + 2 * b, (Hi + 2 * b) * ia); }
// The picture's place is kept as fractions of the face: width rw, center rcx, rcy.
function geom(a, Wi, Hi) {
  var ia = a.natW / a.natH;
  var fillW = fillWidth(ia, Wi, Hi);
  var fitW = Math.min(Wi, Hi * ia);
  if (a.mode === 'fill') { a.rw = fillW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
  else if (a.mode === 'fit') { a.rw = fitW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
  var w = a.rw * Wi, h = w / ia;
  return { x: a.rcx * Wi - w / 2, y: a.rcy * Hi - h / 2, w: w, h: h, fillW: fillW, fitW: fitW };
}
// Image wrap: does the picture cover the face and the bleed on every side?
function coversWrap(a, c) {
  if (!a || !a.img) return false;
  var g = geomForArt(a, a.natW, a.natH, c.Wi, c.Hi), e = 0.02;
  return g.x <= -BLEED + e && g.y <= -BLEED + e && g.x + g.w >= c.Wi + BLEED - e && g.y + g.h >= c.Hi + BLEED - e;
}
function wrapProblem(c) {
  if (!c.wrap) return '';
  var a = ART.front;
  if (!a) return hasLayers() ? 'Image wrap needs a picture that covers the edges. Upload one, or choose Mirrored edge.' : '';
  if (a.loading) return '';
  if (!a.img) return 'We can\'t show this file here, so we can\'t check it for Image wrap. Upload a JPG, PNG or PDF, or choose Mirrored edge.';
  return coversWrap(a, c) ? '' : WRAP_MSG;
}

// Paint the face, plus pad inches around it, into a context whose origin is the top-left corner of the face (units: inches).
// The picture may run past the face (Image wrap); text and clipart are kept on the face, like in the editor.
// Returns false when there is nothing to paint.
function paintArea(ctx, Wi, Hi, pad, noLayers) {
  var a = ART.front, hasL = !noLayers && hasLayers();
  if (!a && !hasL) return false;
  ctx.save();
  ctx.beginPath(); ctx.rect(-pad, -pad, Wi + 2 * pad, Hi + 2 * pad); ctx.clip();
  if (!(S.style === 'acrylic' && S.acr === 'spot' && !(a && a.bgSet))) { // v3: spot white keeps the PNG's transparency
  ctx.fillStyle = (a && a.bg) || '#FFFFFF';
  ctx.fillRect(-pad, -pad, Wi + 2 * pad, Hi + 2 * pad);
  }
  if (a && a.img) {
    var g = geomForArt(a, a.natW, a.natH, Wi, Hi);
    ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(a.img, g.x, g.y, g.w, g.h);
  } else if (a) {
    ctx.fillStyle = '#F1EFEB'; ctx.fillRect(-pad, -pad, Wi + 2 * pad, Hi + 2 * pad);
    ctx.fillStyle = '#3D3A36'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    var fs = Math.min(Hi * 0.1, Wi * 0.07);
    ctx.font = '700 ' + fs + 'px Arial, sans-serif';
    ctx.fillText(a.loading ? 'LOADING YOUR FILE' : 'YOUR FILE', Wi / 2, Hi * 0.44);
    ctx.font = '400 ' + (fs * 0.5) + 'px Arial, sans-serif';
    var nm = a.name.length > 40 ? a.name.slice(0, 37) + '...' : a.name;
    ctx.fillText(nm, Wi / 2, Hi * 0.52);
    if (!a.loading) ctx.fillText('Preview not available', Wi / 2, Hi * 0.58);
  }
  ctx.restore();
  if (hasL) {
    ctx.save();
    ctx.beginPath(); ctx.rect(0, 0, Wi, Hi); ctx.clip();
    window.ArdorCanvasLayers.paint(ctx, Wi, Hi, 'front');
    ctx.restore();
  }
  return true;
}
// the face only (used by ardor-canvas-layers.js)
function paintFace(ctx, Wi, Hi) { return paintArea(ctx, Wi, Hi, 0, false); }

// Phone photos are often stored sideways with a "turn me" tag. Browsers follow the tag, but a JPEG placed in a PDF
// as it is does not, so those photos get an upright copy for the print file. The customer's own file is still
// attached to the order.
function jpegOrientation(file) {
  return file.slice(0, 262144).arrayBuffer().then(function (ab) {
    var v = new DataView(ab), n = v.byteLength, p = 2;
    if (n < 4 || v.getUint16(0) !== 0xFFD8) return 1;
    while (p + 4 <= n) {
      var m = v.getUint16(p);
      if ((m & 0xFF00) !== 0xFF00) return 1;
      if (m === 0xFFDA || m === 0xFFD9) return 1;
      var len = v.getUint16(p + 2);
      if (m === 0xFFE1 && p + 18 <= n && v.getUint32(p + 4) === 0x45786966) {
        var t = p + 10, le = v.getUint16(t) === 0x4949;
        var ifd = t + v.getUint32(t + 4, le);
        if (ifd + 2 > n) return 1;
        var cnt = v.getUint16(ifd, le);
        for (var i = 0; i < cnt; i++) {
          var e = ifd + 2 + i * 12;
          if (e + 12 > n) return 1;
          if (v.getUint16(e, le) === 0x0112) return v.getUint16(e + 8, le) || 1;
        }
        return 1;
      }
      p += 2 + len;
    }
    return 1;
  }).catch(function () { return 1; });
}
function fixOrientation(a) {
  if (!/jpe?g/i.test(a.file.type || '') && !/\.jpe?g$/i.test(a.name)) return;
  a.ready = jpegOrientation(a.file).then(function (o) {
    if (!(o >= 2 && o <= 8) || !a.img) return null;
    var k = Math.min(1, Math.sqrt(40e6 / (a.natW * a.natH)));
    var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(a.natW * k)); cv.height = Math.max(1, Math.round(a.natH * k));
    cv.getContext('2d').drawImage(a.img, 0, 0, cv.width, cv.height);
    return new Promise(function (res) {
      cv.toBlob(function (b) {
        if (b) { a.printFile = new File([b], 'Ardor Canvas Print Art.jpg', { type: 'image/jpeg' }); a.rotated = o; }
        cv.width = cv.height = 1; res(null);
      }, 'image/jpeg', 0.95);
    });
  }).catch(function () {});
}

// v2 (Oct 12, 2026): a finished Ardor template for this size and edge (made by assets/ardor-canvas-tpl.js) goes edge to
// edge on the template: the whole print area (the face, plus the sides and the fold for Image wrap). Only files the
// customer picks or drops (fromUser); AI designs and everything else load exactly as before.
function tplFit(a) {
  var T = window.ArdorCanvasTemplate;
  if (!a || !a.fromUser || !a.img || !T || typeof T.match !== 'function') return false;
  var c = cfg(), m = null;
  try { m = T.match(c, a); } catch (e) { m = null; }
  if (!m) return false;
  a.mode = 'fill'; a.rcx = 0.5; a.rcy = 0.5; a.tpl = { key: m.key };
  toast('Template file detected - placed edge to edge');
  return true;
}
function loadFile(file, face, fromUser) {
    var err = $('[data-abb-error]');
    if (!file) return;
    if (file.size > MAX_FILE) { toast(file.name + ' is over 25 MB. Order with a smaller file, then email the full file to info@ardorprinting.com.'); return; }
    var isImg = /^image\/(png|jpeg|webp|svg\+xml|gif)$/.test(file.type) || /\.(png|jpe?g|webp|svg|gif)$/i.test(file.name);
    var a = { file: file, name: file.name, kind: isImg ? 'image' : 'file', img: null, natW: 1, natH: 1, mode: isImg ? 'fill' : 'fit', rw: 1, rcx: 0.5, rcy: 0.5, bg: '#FFFFFF' }; a.fromUser = fromUser === true;
    if (!isImg) { previewFile(a, face); return; }
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      a.img = img; a.natW = img.naturalWidth || img.width || 1000; a.natH = img.naturalHeight || img.height || 1500;
fixOrientation(a); autoOrient(a); tplFit(a);
      ART[face] = a; S.artVer++; render();
    };
    img.onerror = function () { a.kind = 'file'; a.mode = 'fit'; previewFile(a, face); };
    img.src = url;
    if (err) err.hidden = true;
  }

  // PDF, AI, EPS, TIFF and PSD files: draw a preview so customers see their art in 3D and on the proof.
  // The art viewer file is a straight copy of the banner one, so it still sets window.ArdorBannerArtView.
  var artViewP = null;
  function loadArtView() {
    if (window.ArdorBannerArtView) return Promise.resolve(window.ArdorBannerArtView).then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
    if (!artViewP) artViewP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.artviewUrl; sc.async = true;
      sc.onload = function () { window.ArdorBannerArtView ? res(window.ArdorBannerArtView) : rej(new Error('art view')); };
      sc.onerror = function () { artViewP = null; rej(new Error('art view')); };
      document.head.appendChild(sc);
    });
    return artViewP.then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
  }
  function previewFile(a, face) {
    a.loading = true; a.noPreview = false;
    ART[face] = a; S.artVer++; render();
    a.ready = loadArtView().then(function (av) { return av.preview(a.file, { maxPx: 2400 }); }).then(function (r) {
      if (r && r.ok) { a.img = r.canvas; a.natW = r.natW || r.canvas.width; a.natH = r.natH || r.canvas.height; a.src = r.kind; a.vectorPdf = r.vectorPdf || null; }
      else { a.noPreview = true; a.reason = (r && r.reason) || 'type'; }
    }).catch(function () { a.noPreview = true; a.reason = 'error'; }).then(function () {
      a.loading = false;
      if (ART.front === a) { if (a.img) { autoOrient(a); if (!tplFit(a) && cfg().wrap && !coversWrap(a, cfg())) a.mode = 'fill'; } S.artVer++; render(); }
    });
  }
  function noPreviewText(a) {
    var tail = ' You can still order with this file, and we\'ll email you a proof to approve before we print.';
    if (a.reason === 'ai-no-pdf') return 'This AI file was saved without PDF content, so we can\'t show it here. In Illustrator, use File > Save As, check "Create PDF Compatible File" and upload it again, or upload a PDF, PNG or JPG.' + tail;
    if (a.reason === 'eps') return 'We can\'t show this EPS file here, usually because it has live text or effects. To see it on your canvas, upload it as a PDF or AI file, or outline the text and save the EPS again.' + tail;
    if (a.reason === 'locked') return 'This PDF is password protected, so we can\'t show it here. Upload a copy without a password to see it on your canvas.' + tail;
    if (a.reason === 'blank') return 'This file looks empty, so there\'s nothing to show. Check that you picked the right file.' + tail;
    return 'We can\'t show this file here. Upload a PDF, AI, EPS, PNG or JPG to see it on your canvas.' + tail;
  }
  function needsEmailProof() { var a = ART.front; return !!(a && a.noPreview); }

// ---------- flat drawing: the face with the edge band around it (2D editor and proof) ----------
// The context is in inches with its origin at the outer corner of the band; the face starts DEPTH inches in.
// k = pixels per inch of the target. forEditor: the live text and clipart overlay already shows the layers on the face.
var faceTmp = null;
// Floating frame: the same drawing, but B is the gap plus the frame face (c.margin): the frame in its color, the dark
// gap, then the picture at its exact size. No band and no fold line. Everything is at the same scale as the face.
function drawFlat(ctx, c, k, guides, forEditor) {
  if (c.custom || c.printFrame) { drawFlatWall(ctx, c, k, guides, forEditor); return; } // v3: wall art types
  var Wi = c.Wi, Hi = c.Hi, B = c.margin, TW = Wi + 2 * B, TH = Hi + 2 * B;
  var hasL = hasLayers(), any = !!ART.front || hasL;
  ctx.save();
  ctx.translate(B, B);
  if (c.framed) {
    var G = FRAME_GAP;
    ctx.fillStyle = c.frameHex; ctx.fillRect(-B, -B, TW, TH);
    ctx.fillStyle = '#1E1C1A'; ctx.fillRect(-G, -G, Wi + 2 * G, Hi + 2 * G);
    if (any) paintArea(ctx, Wi, Hi, 0, forEditor);
    else {
      ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Hi * 0.08, Wi * 0.075) + 'px Arial, sans-serif';
      ctx.fillText('Your photo goes here', Wi / 2, Hi / 2);
    }
    // fine lines: the outside of the frame (so a white frame shows on a light background) and its mitred corners
    var fl = Math.max(TW, TH) / 1100;
    ctx.save();
    ctx.setLineDash([]); ctx.lineWidth = fl; ctx.strokeStyle = c.frame === 'black' ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.3)';
    ctx.strokeRect(-B + fl / 2, -B + fl / 2, TW - fl, TH - fl);
    ctx.beginPath();
    ctx.moveTo(-B, -B); ctx.lineTo(-G, -G); ctx.moveTo(Wi + B, -B); ctx.lineTo(Wi + G, -G);
    ctx.moveTo(-B, Hi + B); ctx.lineTo(-G, Hi + G); ctx.moveTo(Wi + B, Hi + B); ctx.lineTo(Wi + G, Hi + G);
    ctx.stroke();
    ctx.restore();
  } else if (!any) {
    ctx.fillStyle = c.edge === 'black' ? '#111111' : '#FFFFFF'; ctx.fillRect(-B, -B, TW, TH);
    ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi);
    ctx.fillStyle = '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.font = '600 ' + Math.min(Hi * 0.08, Wi * 0.075) + 'px Arial, sans-serif';
    ctx.fillText('Your photo goes here', Wi / 2, Hi / 2);
  } else if (c.wrap) {
    // Image wrap: the picture itself runs onto the band
    paintArea(ctx, Wi, Hi, B, forEditor);
  } else if (c.edge === 'mirror') {
    // Mirrored edge: the band is the outer part of the face (picture, text and clipart), flipped outward
    var w = Math.max(2, Math.round(Wi * k)), h = Math.max(2, Math.round(Hi * k));
    var fc = faceTmp || (faceTmp = document.createElement('canvas'));
    if (fc.width !== w || fc.height !== h) { fc.width = w; fc.height = h; }
    var fx = fc.getContext('2d');
    fx.setTransform(w / Wi, 0, 0, h / Hi, 0, 0);
    paintArea(fx, Wi, Hi, 0, false);
    ctx.save();
    ctx.beginPath(); ctx.rect(-B, -B, TW, TH); ctx.clip();
    for (var j = -1; j <= 1; j++) {
      for (var i = -1; i <= 1; i++) {
        if (!i && !j) continue;
        ctx.save();
        ctx.translate(i > 0 ? 2 * Wi : 0, j > 0 ? 2 * Hi : 0);
        ctx.scale(i ? -1 : 1, j ? -1 : 1);
        ctx.drawImage(fc, 0, 0, Wi, Hi);
        ctx.restore();
      }
    }
    ctx.restore();
    if (forEditor && hasL) paintArea(ctx, Wi, Hi, 0, true); else ctx.drawImage(fc, 0, 0, Wi, Hi);
  } else {
    // Black or White edge: a solid band
    ctx.fillStyle = c.edge === 'black' ? '#111111' : '#FFFFFF'; ctx.fillRect(-B, -B, TW, TH);
    paintArea(ctx, Wi, Hi, 0, forEditor);
  }
  if (guides) {
    var lw = Math.max(TW, TH) / 600;
    ctx.save();
    // a light veil over the band when it carries the picture, so the front of the canvas stands out
    if (any && (c.wrap || c.edge === 'mirror')) {
      ctx.beginPath(); ctx.rect(-B, -B, TW, TH); ctx.rect(0, 0, Wi, Hi);
      ctx.fillStyle = 'rgba(255,255,255,0.34)';
      ctx.fill('evenodd');
    }
    // fold line: where the face ends and the canvas folds around the frame (a floating frame has no fold)
    if (!c.framed) {
      ctx.setLineDash([]); ctx.lineWidth = lw * 2.8; ctx.strokeStyle = 'rgba(255,255,255,0.8)';
      ctx.strokeRect(0, 0, Wi, Hi);
      ctx.setLineDash([lw * 8, lw * 5]); ctx.lineWidth = lw * 1.5; ctx.strokeStyle = 'rgba(22,22,27,0.92)';
      ctx.strokeRect(0, 0, Wi, Hi);
    }
    // safe line: keep faces and text inside it
    ctx.setLineDash([]); ctx.lineWidth = lw * 2.6; ctx.strokeStyle = 'rgba(255,255,255,0.7)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    ctx.setLineDash([lw * 6, lw * 4]); ctx.lineWidth = lw * 1.5; ctx.strokeStyle = 'rgba(189,37,44,0.95)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    ctx.setLineDash([]);
    ctx.restore();
  }
  ctx.restore();
}

// ---------- flat layout editor ----------
var lay = { canvas: null, scale: 1, drag: false, lx: 0, ly: 0 };
function drawLayout() {
  var cv = lay.canvas; if (!cv) return;
  var c = cfg();
  var TW = c.Wi + 2 * c.margin, TH = c.Hi + 2 * c.margin;
  var frame = cv.parentNode;
  var cs = window.getComputedStyle(frame), isApp = root.classList.contains('abb--app');
  var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0), padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
  var maxW = isApp ? Math.max(60, (frame.clientWidth || 400) - padX) : Math.max(160, (frame.clientWidth || 400) - 20);
  var maxH = isApp ? Math.max(40, (frame.clientHeight || 300) - padY) : 420;
  var cssW = maxW, cssH = cssW * TH / TW;
  if (cssH > maxH) { cssH = maxH; cssW = cssH * TW / TH; }
  var dpr = Math.min(2, window.devicePixelRatio || 1);
  var pw = Math.round(cssW * dpr), ph = Math.round(cssH * dpr);
  cv.style.width = Math.round(cssW) + 'px'; cv.style.height = Math.round(cssH) + 'px';
  if (cv.width !== pw || cv.height !== ph) { cv.width = pw; cv.height = ph; }
  lay.scale = cssW / TW;
  var ctx = cv.getContext('2d');
  ctx.setTransform(cv.width / TW, 0, 0, cv.height / TH, 0, 0);
  ctx.clearRect(0, 0, TW, TH);
  drawFlat(ctx, c, cv.width / TW, true, true);
}

function editingArt() { return ART.front; }

  function bindLayout() {
    lay.canvas = $('[data-abb-layout-canvas]');
    if (!lay.canvas) return;
    var cv = lay.canvas;
    cv.addEventListener('pointerdown', function (e) {
      var a = editingArt(); if (!a || !a.img) return;
      lay.drag = true; lay.lx = e.clientX; lay.ly = e.clientY;
      try { cv.setPointerCapture(e.pointerId); } catch (er) {}
      e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (!lay.drag) return;
      var a = editingArt(); if (!a) return;
      var c = cfg();
      var dx = (e.clientX - lay.lx) / lay.scale, dy = (e.clientY - lay.ly) / lay.scale;
      lay.lx = e.clientX; lay.ly = e.clientY;
      if (a.mode !== 'custom') { geom(a, c.Wi, c.Hi); a.mode = 'custom'; }
      a.rcx += dx / c.Wi; a.rcy += dy / c.Hi;
      a.rcx = Math.max(-0.5, Math.min(1.5, a.rcx)); a.rcy = Math.max(-0.5, Math.min(1.5, a.rcy));
      S.artVer++; renderArtOnly();
    });
    var end = function () { lay.drag = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    var sc = $('[data-abb-scale]');
    sc.addEventListener('input', function () {
      var a = editingArt(); if (!a || !a.img) return;
      var c = cfg(); var g = geom(a, c.Wi, c.Hi);
      a.mode = 'custom'; a.rw = (parseFloat(sc.value) / 100) * g.fillW / c.Wi;
      S.artVer++; renderArtOnly();
    });
    $('[data-abb-fill]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fill'; S.artVer++; render(); } });
    $('[data-abb-fit]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fit'; S.artVer++; render(); } });
    $('[data-abb-center]').addEventListener('click', function () { var a = editingArt(); if (a) { if (a.mode !== 'custom') { var c = cfg(); geom(a, c.Wi, c.Hi); a.mode = 'custom'; } a.rcx = 0.5; a.rcy = 0.5; S.artVer++; render(); } });
    $('[data-abb-bg]').addEventListener('input', function (e) { var a = editingArt(); if (a) { a.bg = e.target.value; a.bgSet = true; S.artVer++; renderArtOnly(); } });
    if (typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(function () { drawLayout(); }).observe(cv.parentNode); } catch (er) {} }
  }

  function renderArtOnly() {
    drawLayout();
    updateArtUi();
    sync3dSoon();
  }

  function updateArtUi() {
  var c = cfg(), a = ART.front;
  var nameEl = $('[data-abb-file-name]');
  nameEl.hidden = !a; nameEl.textContent = a ? ('Selected: ' + a.name) : '';
  var ctl = $('[data-abb-layout-controls]');
  ctl.hidden = !(a && a.img);
  var empty = $('[data-abb-layout-empty]');
  var msg = '', level = '';
  if (a && a.loading) { empty.hidden = false; empty.textContent = 'Loading a preview of your file…'; }
  else if (a && a.noPreview) { empty.hidden = true; msg = noPreviewText(a); level = 'soft'; }
  else if (a && a.kind !== 'image') { empty.hidden = false; empty.textContent = 'This is a preview of your file. We print from your original, so the canvas will look sharper than the preview.'; }
  else if (!a) { empty.hidden = false; empty.textContent = 'No picture yet. Upload yours above.'; }
  else empty.hidden = true;
  if (lay.canvas) lay.canvas.style.touchAction = (a && a.img) ? 'none' : 'auto';
  if (a && a.img) {
    var g = geom(a, c.Wi, c.Hi);
    var sc = $('[data-abb-scale]');
    var pct = Math.round(100 * g.w / g.fillW);
    sc.value = String(Math.max(10, Math.min(400, pct)));
    $('[data-abb-scale-out]').textContent = pct + '%';
    $('[data-abb-bg]').value = a.bg;
    // canvas is looked at up close: under 60 pixels per inch looks blurry, under 100 can look soft
    if (a.kind === 'image' && !/svg/i.test(a.file.type || a.name)) {
      var ppi = Math.round(a.natW / g.w);
      if (ppi < 60) { level = 'bad'; msg = 'This picture is only about ' + ppi + ' pixels per inch at this size, so it will look blurry on canvas. Choose a smaller size or upload a bigger picture.'; }
      else if (ppi < 100) { level = 'soft'; msg = 'This picture is about ' + ppi + ' pixels per inch at this size, so it may look soft up close. 100 or more is best.'; }
    }
  }
  var sw = spotWarn(c, a); if (sw && level !== 'bad') { msg = sw; level = 'soft'; } // v3
  var wp = wrapProblem(c);
  if (wp) { msg = wp; level = 'bad'; }
  // after Add to cart was stopped by Image wrap, the same words show as the error until the picture covers the edges
  if (wrapErr) { if (wp) showErr(wp); else { wrapErr = false; showErr(''); } }
  [$('[data-abb-warn]'), $('[data-abb-res-warn]')].forEach(function (el, i) {
    if (!el) return;
    var m = (i === 0 && wrapErr && wp) ? '' : msg;
    el.hidden = !m; el.textContent = m;
    if (m && level) el.setAttribute('data-level', level); else el.removeAttribute('data-level');
  });
}

// ---------- render ----------
function specLines(c) {
  var out = [];
  if (STYLES_ON.length > 1) out.push(['Style', c.styleName]);
  if (c.kind === 'acrylic') out.push(['Acrylic', c.acrLabel]);
  out.push(['Size', sizeLabel(c)]);
  if (!c.square && !c.custom) out.push(['Orientation', orientLabel(c)]);
  if (c.framed) out.push(['Frame color', c.frameName]);
  else if (c.printFrame) out.push(['Frame', c.frameName]);
  else if (c.kind === 'acrylic') { out.push(['Drill Holes & Stand off', c.hwName]); out.push(['Round Corners', c.cornerName]); }
  else if (c.kind === 'roll') out.push(['Material', c.material]);
  else out.push(['Edge', c.edgeName]);
  out.push(['Quantity', String(c.qty)]);
  return out;
}

function render() {
  var c = cfg();
  var p = price(c);

  // style: gallery wrap or floating frame (the row only shows when the floating frame is offered)
  var styleWrap = $('[data-abb-style-wrap]');
  if (styleWrap) styleWrap.hidden = STYLES_ON.length < 2;
  if (STYLES_ON.length > 1) {
    fill($('[data-abb-styles]'), STYLES_ON.map(function (st) {
      var lo = styleFrom(st.id);
      return optBtn({ on: c.style === st.id, data: ['style', st.id], html: '<span class="abb-opt__name">' + esc(st.name) + '</span>' + (lo ? '<span class="abb-opt__price">From ' + money(lo / 100) + '</span>' : ''), pick: function () { pickStyle(st.id); } });
    }));
    setText('[data-abb-style-note]', styleById(c.style).note);
    setText('[data-abb-style-moved]', styleNote);
  }

  // size: every size the chosen style has, with its price
  if (c.custom) renderCustomSizes(c); else {
  var sizeList = c.printFrame ? PSIZES : (c.framed ? FSIZES.map(function (fz) { var fv = frameVariant(fz, c.frame); return { key: fz.key, w: fz.w, h: fz.h, cents: fv.cents, available: fv.available }; }) : SIZES);
  fill($('[data-abb-sizes]'), sizeList.map(function (z) {
    var html = '<span class="abb-opt__name">' + esc(fmt(z.w) + ' x ' + fmt(z.h) + ' in') + '</span><span class="abb-opt__price">' + money(z.cents / 100) + '</span>';
    return optBtn({ on: z.key === c.size.key, html: html, data: ['size', z.key], disabled: !z.available, pick: function () { pickSize(z.key); } });
  }));
  }

  // orientation: same price either way; square sizes have none
  var orientWrap = $('[data-abb-orient-wrap]');
  if (orientWrap) orientWrap.hidden = c.square || c.custom;
  fill($('[data-abb-orients]'), [
    optBtn({ on: c.orient === 'portrait', data: ['orient', 'portrait'], html: '<span class="abb-opt__name">Portrait</span><span class="abb-opt__sub">' + esc(fmt(c.size.w) + ' in wide x ' + fmt(c.size.h) + ' in tall') + '</span>', pick: function () { pickOrient('portrait'); } }),
    optBtn({ on: c.orient === 'landscape', data: ['orient', 'landscape'], html: '<span class="abb-opt__name">Landscape</span><span class="abb-opt__sub">' + esc(fmt(c.size.h) + ' in wide x ' + fmt(c.size.w) + ' in tall') + '</span>', pick: function () { pickOrient('landscape'); } })
  ]);

  // edge style: same price for every one
  fill($('[data-abb-edges]'), EDGES.map(function (e) {
    return optBtn({ chip: true, on: c.edge === e.id, data: ['edge', e.id], label: e.name, pick: function () { pickEdge(e.id); } });
  }));
  setText('[data-abb-edge-note]', edgeById(c.edge).note);
  // floating frame: no edge style; a frame color instead (same price for every color)
  var edgeWrap = $('[data-abb-edge-wrap]'), frameWrap = $('[data-abb-frame-wrap]');
  if (edgeWrap) edgeWrap.hidden = c.style !== 'wrap';
  if (frameWrap) frameWrap.hidden = !(c.framed || c.printFrame);
  renderWallRows(c);
  if (c.printFrame) {
    fill($('[data-abb-colors]'), [optBtn({ chip: true, on: true, data: ['color', 'wood'], label: 'Wood', pick: function () {} })]);
    setText('[data-abb-frame-note]', 'Natural wood style frame, ' + fmt(PRINT_FACE) + ' in wide, made from lightweight recycled polystyrene. Hanging hardware included.');
  }
  if (c.framed) {
    var curF = fsizeByKey(c.size.key);
    fill($('[data-abb-colors]'), FCOLORS.map(function (f) {
      return optBtn({ chip: true, on: c.frame === f.id, data: ['color', f.id], label: f.name, disabled: !(curF && curF.v[f.id]), pick: function () { pickFrame(f.id); } });
    }));
    setText('[data-abb-frame-note]', 'The frame color does not change the price.');
  }

  // number the steps that are showing
  var n = 0;
  $$('.abb-step').forEach(function (st) { var b = $('.abb-step__num', st); if (!b) return; if (!st.hidden) n++; b.textContent = String(n || 1); });

  // quantity
  var qI = $('[data-abb-qty]');
  if (document.activeElement !== qI) qI.value = String(c.qty);

  // price box
  setText('[data-abb-total]', money(p.charged));
  setText('[data-abb-mbar-total]', money(p.charged));
  setText('[data-abb-dbar-total]', money(p.charged));
  var eachEl = $('[data-abb-each]');
  eachEl.hidden = c.qty < 2;
  eachEl.textContent = money(p.unit) + ' each × ' + c.qty;
  var specs = $('[data-abb-specs]');
  if (specs) { specs.textContent = ''; specLines(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; specs.appendChild(li); }); }

  // summary chips and the tip on the stage
  setText('[data-abb-chip-size]', faceLabel(c) + ' ' + typeNoun(c));
  setText('[data-abb-chip-mat]', c.kind === 'acrylic' ? c.acrName : (c.kind === 'roll' ? 'Ships rolled' : orientLabel(c)));
  setText('[data-abb-chip-sides]', c.framed ? c.frameName + ' frame' : (c.printFrame ? 'Wood frame' : (c.kind === 'acrylic' ? (c.standoff ? 'Stand offs' : (c.holes.length ? 'Drilled holes' : 'No holes')) : (c.kind === 'roll' ? '15mil. canvas' : c.edgeName))));
  setText('[data-abb-layout-help]', c.custom || c.printFrame
    ? (c.kind === 'acrylic' ? 'Drag the picture to move it. Keep faces and text inside the dashed red line and clear of the holes. Your picture is printed at this exact size.' : 'Drag the picture to move it. Keep faces and text inside the dashed red line. Your picture is printed at this exact size' + (c.printFrame ? ' and set in the frame.' : ' on unstretched canvas.'))
    : c.framed
    ? 'Drag the picture to move it. Keep faces and text inside the dashed red line. Your picture is printed at this exact size and set in the frame.'
    : 'Drag the picture to move it. Keep faces and text inside the dashed red line. The part outside the dashed fold line wraps around the sides of the frame.');
  setText('[data-abb-tip]', c.wrap
    ? 'Keep faces and text inside the red line. The outer 1.5 in wraps the sides.'
    : 'Keep faces and text inside the red line');

  updateArtUi();
  drawLayout();
  sync3d();
}

// ---------- 3D viewer (window.ArdorCanvas3D, three.js). Everything else works without it. ----------
// The 3D view gets the face canvas the builder paints. Mirrored, Black and White edges send the face only (the 3D view
// makes the sides itself). Image wrap sends the face plus the DEPTH band on every side, and the 3D view folds the band
// onto the sides.
var faceCv = null, faceSent = '', engSent = '', syncQueued = false;
function paintFaceCanvas(c) {
  var pad = c.wrap ? DEPTH : 0, TW = c.Wi + 2 * pad, TH = c.Hi + 2 * pad;
  var k = Math.min(100, 1400 / Math.max(TW, TH));
  var w = Math.round(TW * k), h = Math.round(TH * k);
  var cv = faceCv || (faceCv = document.createElement('canvas'));
  if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
  var ctx = cv.getContext('2d');
  ctx.setTransform(w / TW, 0, 0, h / TH, 0, 0);
  ctx.clearRect(0, 0, TW, TH);
  if (!(c.kind === 'acrylic' && c.acr === 'spot')) { ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, TW, TH); }
  ctx.translate(pad, pad);
  if (!paintArea(ctx, c.Wi, c.Hi, pad, false)) {
    ctx.fillStyle = '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.font = '600 ' + Math.min(c.Hi * 0.08, c.Wi * 0.075) + 'px Arial, sans-serif';
    ctx.fillText('Your photo goes here', c.Wi / 2, c.Hi / 2);
  }
  if (c.kind === 'acrylic') { drawHoles(ctx, c, true); if (c.acr === 'clear') clearToAlpha(cv); } // v3: drilled holes on the face; clear acrylic
  return cv;
}
function sync3d() {
  if (!eng) return;
  var c = cfg();
  try {
    // everything is sent in inches at true size: the gallery wrap is 1.5 in deep, the floating frame 1.25 in
    var key = [c.Wi, c.Hi, c.edge, c.style, c.frame, c.acr, c.hw, c.corner].join('|');
    if (key !== engSent) {
      engSent = key;
      eng.set(c.framed
        ? { w: c.Wi, h: c.Hi, depth: c.depth, style: 'frame', frame: c.frame, gap: FRAME_GAP, face: FRAME_FACE }
        : c.printFrame ? { w: c.Wi, h: c.Hi, depth: PRINT_DEPTH, style: 'frame', frame: 'wood', gap: 0.02, face: PRINT_FACE }
        : c.custom ? { w: c.Wi, h: c.Hi, depth: c.depth, style: c.kind, acr: c.acr, corner: c.cornerIn, holes: c.holes, standoff: c.standoff }
        : { w: c.Wi, h: c.Hi, depth: c.depth, style: 'wrap', edge: c.edge });
    }
    var cv = paintFaceCanvas(c), fkey = key + '|' + cv.width + 'x' + cv.height;
    if (fkey !== faceSent) { faceSent = fkey; eng.setFace('front', cv); }
    eng.refresh();
  } catch (e) {}
}
function sync3dSoon() {
  if (!eng || syncQueued) return;
  syncQueued = true;
  requestAnimationFrame(function () { syncQueued = false; sync3d(); });
}
function view3d(which) { if (eng) { try { eng.view(which); } catch (e) {} } }
  function startEngine() {
    var host = $('[data-abb-canvas]'), nogl = $('[data-abb-nogl]'), hint = $('[data-abb-hint]'), vw = $('[data-abb-viewer]');
    try { eng = (window.ArdorCanvas3D && host) ? window.ArdorCanvas3D.create(host, { background: '#f4f3f0' }) : null; } catch (e) { eng = null; }
    if (!eng) { if (nogl) nogl.hidden = false; if (hint) hint.hidden = true; return; }
    host.addEventListener('pointerdown', function () { if (vw) vw.classList.add('is-dragging'); if (hint) hint.classList.add('is-gone'); });
    var up = function () { if (vw) vw.classList.remove('is-dragging'); };
    host.addEventListener('pointerup', up); host.addEventListener('pointercancel', up); host.addEventListener('pointerleave', up);
    sync3d();
  }

  // ---------- proof sheet and print files ----------
// The proof drawing is the face with the edge band around it, the dashed fold line and the dashed red safe line.
function proofCanvas() {
  var c = cfg(), TW = c.Wi + 2 * c.margin, TH = c.Hi + 2 * c.margin;
  var long = 1800, cw, ch;
  if (TW >= TH) { cw = long; ch = Math.max(60, Math.round(long * TH / TW)); } else { ch = long; cw = Math.max(60, Math.round(long * TW / TH)); }
  var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
  var ctx = cv.getContext('2d');
  ctx.setTransform(cw / TW, 0, 0, ch / TH, 0, 0);
  drawFlat(ctx, c, cw / TW, true, false);
  var u = Math.max(TW, TH) / long; // inches per canvas pixel
  ctx.save();
  ctx.setLineDash([]); ctx.lineWidth = u * 2; ctx.strokeStyle = '#0C0D0D'; ctx.strokeRect(0, 0, TW, TH);
  ctx.restore();
  return cv;
}

// Where the picture sits, in inches from the top-left corner of the face (nw x nh = the picture's own pixels or points).
function geomForArt(a, nw, nh, Wi, Hi) {
  var ia = nw / nh, ba = Wi / Hi;
  if (a.kind !== 'image' && !a.img) {
    if (Math.abs(ia - ba) / ba < 0.01) return { x: 0, y: 0, w: Wi, h: Hi };
    var fw = Math.min(Wi, Hi * ia), fh = fw / ia;
    return { x: (Wi - fw) / 2, y: (Hi - fh) / 2, w: fw, h: fh, note: 'The uploaded PDF is a different shape than the canvas, so it was placed to fit, centered, with white around it.' };
  }
  var fillW = fillWidth(ia, Wi, Hi), fitW = Math.min(Wi, Hi * ia);
  var w = a.mode === 'fill' ? fillW : (a.mode === 'fit' ? fitW : a.rw * Wi);
  var cx = a.mode === 'custom' ? a.rcx * Wi : Wi / 2, cy = a.mode === 'custom' ? a.rcy * Hi : Hi / 2, h = w / ia;
  return { x: cx - w / 2, y: cy - h / 2, w: w, h: h };
}

function loadPdfTool() {
    if (window.ArdorCanvasPDF) return Promise.resolve();
    return new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.pdfUrl; sc.async = true;
      sc.onload = function () { window.ArdorCanvasPDF ? res() : rej(new Error('pdf tool')); }; sc.onerror = function () { rej(new Error('pdf tool')); };
      document.head.appendChild(sc);
    });
  }

  function logoImage() {
    var el = document.querySelector('.site-header__logo img, .header__logo img, header img');
    var src = CONF.logoUrl || (el && (el.currentSrc || el.src));
    if (!src) return Promise.resolve(null);
    return fetch(src).then(function (r) { if (!r.ok) throw new Error('logo'); return r.blob(); }).then(function (bl) {
      return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(bl); });
    }).catch(function () { return null; });
  }

  function placementText(a, c) {
  if (!a || !a.img) return '';
  if (a.tpl && a.mode === 'fill' && window.ArdorCanvasTemplate && window.ArdorCanvasTemplate.spec(c).key === a.tpl.key) return 'Ardor template file, placed edge to edge' + (c.wrap ? ' (front, sides and the part that folds to the back)' : '') + ', background ' + a.bg;
    if (a.mode === 'fill') return c.wrap ? 'Fill the canvas and its edges (the picture may crop)' : 'Fill canvas (edges of the picture may crop)';
  if (a.mode === 'fit') return 'Fit whole image, background ' + a.bg;
  var g = geom(a, c.Wi, c.Hi);
  return 'Custom: picture ' + fmt(g.w) + ' x ' + fmt(g.h) + ' in, top-left at ' + fmt(g.x) + ', ' + fmt(g.y) + ' in from the top-left of the face, background ' + a.bg;
}
function artworkLabel() { return ART.front ? ART.front.name : (hasLayers() ? 'Text and clipart added in the builder' : 'None'); }

function proofSpecs(c) {
  var out = [];
  if (STYLES_ON.length > 1) out.push(['Style', c.styleName]);
  if (c.kind === 'acrylic') out.push(['Acrylic', c.acrLabel]);
  out.push(['Size', sizeLabel(c)]);
  if (!c.custom) out.push(['Orientation', orientFull(c)]);
  if (c.framed) out.push(['Frame color', c.frameName]);
  else if (c.printFrame) out.push(['Frame', c.frameName + ' (natural wood style, ' + fmt(PRINT_FACE) + ' in wide)']);
  else if (c.kind === 'acrylic') { out.push(['Drill Holes & Stand off', c.hwName]); out.push(['Round Corners', c.cornerName]); }
  else if (c.kind === 'roll') out.push(['Material', c.material + ', not stretched, ships rolled']);
  else out.push(['Edge', c.edgeName]);
  if (c.kind === 'acrylic') out.push(['Thickness', '1/4 in clear acrylic' + (c.standoff ? ', 1 in off the wall on stand offs' : '')]);
  else if (c.kind !== 'roll') out.push(['Frame depth', fmt(c.depth) + ' in']);
  out.push(['Quantity', String(c.qty)]);
  out.push(['Delivery', S.delivery === 'pickup' ? 'Pick up at our Snohomish shop' : shipLabel()]);
  out.push(['Artwork', artworkLabel()]);
  var pl = placementText(ART.front, c); if (pl) out.push(['Placement', pl]);
  var added = layerSummary(); if (added) out.push(['Added in the builder', added]);
  var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) out.push(['Notes', notes]);
  return out;
}

// Makes the proof PDF and the print PDF.
// Print file: Mirrored, Black and White edges = the exact face size, no bleed, no marks.
// Image wrap = the face plus BLEED inches on every side, with the picture placed so the face matches the preview.
// ---------- proof sheet shared by the builders (assets/ardor-proofsheet.js, Oct 9 2026): the 3D view on page 1, the print file next to it or on page 2 ----------
function proofViews(c) {
var out = [];
try { sync3d(); } catch (e) {}
if (!eng || typeof eng.snapshot !== 'function') return out;
[['home', 'On the wall'], ['side', 'From the side']].forEach(function (v) {
try { var cv = eng.snapshot(1000, 1030, v[0]); if (cv) out.push({ canvas: cv, caption: v[1] }); } catch (e) {}
});
return out;
}
function proofSheet(P, c, mode, o) {
var PS = window.ArdorProofSheet;
if (!PS || typeof PS.build !== 'function') return P.buildProof(o);
o.noun = (c.custom || c.printFrame) ? typeNoun(c) : 'canvas print'; o.preview = mode === 'preview'; o.views = proofViews(c);
return PS.build(o).catch(function () { return P.buildProof(o); });
}
function buildFiles(c, approval, proofMode) {
  return loadPdfTool().then(function () {
    var P = window.ArdorCanvasPDF, Wi = c.Wi, Hi = c.Hi, TW = Wi + 2 * c.margin, TH = Hi + 2 * c.margin;
    var a = ART.front;
    var out = { notes: [], proof: null, print: null, printW: 0, printH: 0 };
    // the file used for vector drawing: the PDF/AI itself, or the PDF made from an EPS
    var vectorArt = function (x) {
      if (!x || x.kind === 'image') return null;
      if (x.src === 'eps' && x.vectorPdf) return { file: new File([x.vectorPdf], 'artwork.pdf', { type: 'application/pdf' }), name: 'artwork.pdf' };
      if (x.src === 'pdf' || x.src === 'ai' || (!x.src && (/\.(pdf|ai)$/i.test(x.name) || /pdf/i.test(x.file.type || '')))) return x;
      return null;
    };
    var date = (approval && approval.when) || stampLabel(new Date());
    var edgeDim = c.framed ? ' in picture + frame' : (c.printFrame ? ' in picture + ' + fmt(PRINT_FACE) + ' in frame' : (c.custom ? ' in, with the wall around it' : ' in face + ' + fmt(DEPTH) + ' in edges'));
    var face = { label: c.framed ? 'Front, in its ' + c.frameName.toLowerCase() + ' floating frame' : (c.printFrame ? 'Front, in its wood frame' : (c.kind === 'acrylic' ? 'Front of your acrylic print' + (c.holes.length ? ', with the ' + (c.standoff ? 'stand offs' : 'holes') : '') : (c.kind === 'roll' ? 'Your canvas roll, laid flat' : 'Front, with the edges that fold around the frame'))), canvas: proofCanvas(), fallback: null, wIn: TW, hIn: TH, wLabel: fmt(Wi) + edgeDim, hLabel: fmt(Hi) + edgeDim, underlay: null };
    var proofP = logoImage().then(function (logo) {
      return proofSheet(P, c, proofMode, {
        logo: logo, title: wallTitle(c, 'Proof'), panelTitle: (c.custom || c.printFrame) ? 'Your ' + typeNoun(c) : 'Your canvas print', sideBySide: false,
        legend: c.kind === 'acrylic' ? 'Dashed red line: keep faces and text inside it. Printed at this exact size on the back of 1/4 in clear acrylic (' + c.acrName + ').' + (c.holes.length ? ' Keep text clear of the ' + (c.standoff ? 'stand offs.' : 'holes.') : '')
          : c.kind === 'roll' ? 'Dashed red line: keep faces and text inside it. Printed at this exact size on 15 mil canvas, not stretched, shipped rolled.'
          : c.printFrame ? 'Dashed red line: keep faces and text inside it. The picture is printed at its exact size and set in a wood frame.'
          : c.framed
          ? 'Dashed red line: keep faces and text inside it. The picture is printed at its exact size and set in a ' + c.frameName.toLowerCase() + ' floating frame.'
          : 'Dashed black line: fold line, where the front ends and the ' + c.edgeName.toLowerCase() + ' begins. Dashed red line: keep faces and text inside it.',
        approval: approval || null, date: date, faces: [face], specs: proofSpecs(c),
        footer: 'Ardor Printing | 12531 Old Snohomish Monroe Rd., Snohomish, WA 98290 | (425) 629-0796 | ardorprinting.com'
      });
    }).catch(function () { return null; });
    var hasL = hasLayers();
    var printable = a ? (a.kind === 'image' || !!vectorArt(a)) : hasL;
    var printP = Promise.resolve();
    if (proofMode === 'preview') { /* PDF button: the proof only, no print files */ } else if (!printable) out.notes.push('The print file was not made automatically for this file type. Use the original artwork file.');
    else {
      if (a && a.src === 'eps') out.notes.push('The customer uploaded an EPS. The print file was made from it by the online converter, so check it against the original EPS before printing.');
      if (c.kind === 'acrylic' && c.acr === 'spot') { // v3: Spot White Backing prints from a PNG with a transparent background
        printP = spotPng(c).then(function (r) { out.print = r.blob; out.printPng = true; out.printW = Wi; out.printH = Hi; out.notes.push('Spot White Backing: the print file is a PNG with a transparent background (' + r.w + ' x ' + r.h + ' px, ' + Math.round(r.ppi) + ' pixels per inch). White goes only behind the art; transparent areas stay clear.'); })
          .catch(function (e) { out.print = null; out.notes.push('The PNG print file could not be made automatically (' + ((e && e.message) || 'error') + '). Use the original artwork file.'); });
      } else {
      var b = c.wrap ? BLEED : 0, PWi = Wi + 2 * b, PHi = Hi + 2 * b;
      // buildPrint takes the page size in feet and the picture's place in inches from the top-left of the page
      var mkJob = function (art, geomFor) {
        return { title: wallTitle(c, 'Print File'), stamp: date, W: PWi / 12, H: PHi / 12, holes: [], dotIn: 0.125, faces: [{ art: art, bg: (a && a.bg) || '#FFFFFF', geomFor: geomFor }] };
      };
      var jobP;
      if (hasL) {
        // text or clipart: one flattened image of everything that prints (the face, plus the bleed for Image wrap)
        jobP = window.ArdorCanvasLayers.composite('front', Wi, Hi, a, b).then(function (r) {
          out.notes.push(LAYER_NOTE);
          return mkJob({ file: r.file, name: r.file.name, kind: 'image' }, function () { return { x: 0, y: 0, w: PWi, h: PHi }; });
        });
      } else {
        if (a.rotated) out.notes.push('The photo carried a camera rotation tag, so the print file uses an upright copy of it.');
        var art = a.kind === 'image' ? { file: a.printFile || a.file, name: a.name, kind: 'image' } : vectorArt(a);
        jobP = Promise.resolve(mkJob(art, function (nw, nh) { var g = geomForArt(a, nw, nh, Wi, Hi); return { x: g.x + b, y: g.y + b, w: g.w, h: g.h, note: g.note }; }));
      }
      printP = jobP.then(function (j) { return P.buildPrint(j, false); }).then(function (r) {
        r.notes.forEach(function (n) { if (out.notes.indexOf(n) < 0) out.notes.push(n); });
        out.print = r.blob; out.printW = PWi; out.printH = PHi;
      }).catch(function (e) { out.print = null; out.notes.push('The print file could not be made automatically (' + ((e && e.message) || 'error') + '). Use the original artwork file.'); });
      }
    }
    return Promise.all([proofP, printP]).then(function (r) { out.proof = r[0]; return out; });
  });
}

// ---------- messages, tracking, stamps ----------
  function toast(msg) {
    var t = $('[data-abb-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function showErr(msg) { var e = $('[data-abb-error]'); if (!e) return; e.textContent = msg; e.hidden = !msg; }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    // disabled Oct 18 2026 – duplicate of Shopify Google & YouTube / Facebook app event (add_to_cart / AddToCart). The generate_lead / Lead branch fired on the "Go to the quote form" link click, not on a sent lead; the lead itself is the HubSpot form submit, which GTM already sends as generate_lead + the Google Ads quote conversion. The dataLayer push above stays. Undo: remove "// " from the next 2 lines.
    // try { if (window.gtag) window.gtag('event', name === 'ardor_canvas_added_to_cart' ? 'add_to_cart' : 'generate_lead', { currency: 'USD', value: data.value }); } catch (e) {}
    // try { if (window.fbq) window.fbq('track', name === 'ardor_canvas_added_to_cart' ? 'AddToCart' : 'Lead', { currency: 'USD', value: data.value }); } catch (e) {}
  }

  function stampLabel(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }); }
  function stampFile(d) {
    var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + h12 + '-' + pad(d.getMinutes()) + ' ' + ap;
  }

  // ---------- proof approval and signature ----------
  var approveCtl = null;
  var sigPad = { ink: false, drawing: false, lx: 0, ly: 0, mode: 'draw' };
  var SIG_FONT = '"Dancing Script", "Segoe Script", "Snell Roundhand", "Brush Script MT", cursive';
  function loadSigFont() {
    if (document.querySelector('link[data-abb-sig-font]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.setAttribute('data-abb-sig-font', '');
    l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
    document.head.appendChild(l);
  }
  function setSigMode(mode) {
    sigPad.mode = mode;
    $$('[data-abb-sig-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-sig-mode') === mode ? 'true' : 'false'); });
    $('[data-abb-sig-type]').hidden = mode !== 'type';
    $('[data-abb-sig-draw]').hidden = mode !== 'draw';
    if (mode === 'draw') sizeSig();
    if (mode === 'type') {
      var t = $('[data-abb-sig-text]'); if (!t.value) t.value = ($('[data-abb-ap-name]').value || '').trim();
      $('[data-abb-sig-preview]').textContent = t.value;
    }
  }
  function typedSigCanvas(text) {
    var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 260;
    var ctx = cv.getContext('2d'); var size = 120;
    ctx.font = '600 ' + size + 'px ' + SIG_FONT;
    while (ctx.measureText(text).width > 940 && size > 30) { size -= 6; ctx.font = '600 ' + size + 'px ' + SIG_FONT; }
    ctx.fillStyle = '#111111'; ctx.textBaseline = 'middle'; ctx.fillText(text, 30, 140);
    return cv;
  }
  function sizeSig() {
    var cv = $('[data-abb-sig]'); var dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.max(200, Math.round(cv.clientWidth * dpr)); cv.height = Math.round(150 * dpr);
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.6; ctx.strokeStyle = '#111111';
    sigPad.ink = false;
  }
  function bindSig() {
    var cv = $('[data-abb-sig]');
    var pos = function (e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    cv.addEventListener('pointerdown', function (e) { sigPad.drawing = true; var p = pos(e); sigPad.lx = p[0]; sigPad.ly = p[1]; try { cv.setPointerCapture(e.pointerId); } catch (er) {} e.preventDefault(); });
    cv.addEventListener('pointermove', function (e) {
      if (!sigPad.drawing) return;
      var p = pos(e), ctx = cv.getContext('2d');
      ctx.beginPath(); ctx.moveTo(sigPad.lx, sigPad.ly); ctx.lineTo(p[0], p[1]); ctx.stroke();
      sigPad.lx = p[0]; sigPad.ly = p[1]; sigPad.ink = true;
      $('.abb-sig').classList.remove('is-missing');
    });
    var end = function () { sigPad.drawing = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    $('[data-abb-sig-clear]').addEventListener('click', function () { sizeSig(); });
  }
  function closeApproval(result) {
    var dlg = $('[data-abb-approve]');
    if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
    var ctl = approveCtl; approveCtl = null;
    if (!ctl) return;
    if (result) ctl.resolve(result); else ctl.reject({ cancel: true });
  }
  function openApproval(c) {
  return new Promise(function (resolve, reject) {
    approveCtl = { resolve: resolve, reject: reject };
    var box = $('[data-abb-approve-proof]'); box.textContent = '';
    var a = ART.front, isFile = a && a.kind !== 'image';
    var cv = proofCanvas();
    var fig = document.createElement('figure'); fig.className = 'abb-approve__fig';
    var im = new Image(); im.alt = (c.custom || c.printFrame) ? 'Proof of your ' + typeNoun(c) : c.framed ? 'Proof of your framed canvas print: the picture in its floating frame' : 'Proof of your canvas print: the front, with the edges that fold around the frame'; im.src = cv.toDataURL('image/jpeg', 0.86);
    var cap = document.createElement('figcaption');
    cap.textContent = ((c.custom || c.printFrame) ? faceLabel(c) + ' ' + typeNoun(c) + (c.kind === 'acrylic' ? ', ' + c.acrLabel + ', ' + c.hwName.toLowerCase() + ', ' + (c.cornerIn ? c.cornerName + ' round corners' : 'square corners') + '.' : (c.printFrame ? ' in a wood frame. The picture is printed at this exact size.' : ', printed at this exact size, not stretched, shipped rolled.'))
      : c.framed
      ? faceLabel(c) + ' picture in a ' + c.frameName.toLowerCase() + ' floating frame, ' + fmt(c.depth) + ' in deep. The picture is printed at this exact size, with a narrow gap between it and the frame.'
      : faceLabel(c) + ' front, ' + c.edgeName.toLowerCase() + '. Everything outside the dashed fold line wraps around the ' + fmt(DEPTH) + ' in deep frame.') + (isFile ? ' We print from your original file (' + a.name + ').' : '');
    fig.appendChild(im); fig.appendChild(cap); box.appendChild(fig);
    setText('[data-abb-approve-help]', 'Check the size, the ' + (c.kind === 'acrylic' ? 'acrylic type, holes and corners' : (c.custom ? 'material' : (c.framed || c.printFrame ? 'frame' + (c.framed ? ' color' : '') : 'edges'))) + ', the spelling and where your picture sits. We print exactly what you approve here.');
    var ul = $('[data-abb-approve-specs]'); ul.textContent = '';
    proofSpecs(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; ul.appendChild(li); });
    $('[data-abb-approve-error]').hidden = true;
    $('[data-abb-ap-colors]').checked = false;
    var dlg = $('[data-abb-approve]');
    loadSigFont();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    setSigMode(coarse ? 'draw' : 'type');
  });
}
function submitApproval(e) {
    var PL = window.ArdorProofLater; if (PL && PL.on() && !(window.ArdorArtLink && window.ArdorArtLink.emailChosen(root))) { e.preventDefault(); var plr = PL.approve(root); if (plr) closeApproval(plr); return; } // DSN Oct 25 2026: one approval box now; name + typed signature in the cart, email + phone at checkout
    var AL = window.ArdorArtLink; if (AL && AL.emailChosen(root)) { e.preventDefault(); var pe = AL.proofEmail(root); if (pe) closeApproval({ emailProof: true, email: pe }); return; } // ART0 Oct 19 2026: "Email me the proof to approve"
    e.preventDefault();
    var err = $('[data-abb-approve-error]'), msgs = [];
    var name = ($('[data-abb-ap-name]').value || '').trim(), email = ($('[data-abb-ap-email]').value || '').trim(), phone = ($('[data-abb-ap-phone]').value || '').trim();
    if (name.length < 2) msgs.push('your full name');
    if (!/^\S+@\S+\.\S+$/.test(email)) msgs.push('a valid email');
    if ((phone.match(/\d/g) || []).length < 7) msgs.push('a phone number');
    var typed = ($('[data-abb-sig-text]').value || '').trim();
    if (sigPad.mode === 'draw' && !sigPad.ink) { msgs.push('your signature'); $('.abb-sig').classList.add('is-missing'); }
    if (sigPad.mode === 'type' && typed.length < 2) { msgs.push('your typed signature'); $('[data-abb-sig-type]').classList.add('is-missing'); }
    if (!$('[data-abb-ap-colors]').checked) msgs.push('a check in the color box');
    if (msgs.length) { err.textContent = 'Please add ' + msgs.join(', ') + '.'; err.hidden = false; return; }
    var at = new Date(), when = stampLabel(at), mode = sigPad.mode;
    var fontReady = (mode === 'type' && document.fonts && document.fonts.load) ? document.fonts.load('600 60px "Dancing Script"').catch(function () {}) : Promise.resolve();
    fontReady.then(function () {
      var copy;
      if (mode === 'type') copy = typedSigCanvas(typed);
      else { var src = $('[data-abb-sig]'); copy = document.createElement('canvas'); copy.width = src.width; copy.height = src.height; copy.getContext('2d').drawImage(src, 0, 0); }
      closeApproval({ name: name, email: email, phone: phone, when: when, at: at, sig: copy, method: mode === 'type' ? 'typed' : 'drawn', statements: ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.'] });
    });
  }

  // ---------- cart ----------
// One cart line: the chosen size's own variant on this product, the quantity, and everything else as line item properties.
function setupMsg() { return 'Online ordering for this canvas size is being set up. Call ' + PHONE + ' or request a quote.'; }

// v2 (Oct 12, 2026): the cart refuses any add-to-cart request over 20 MB ("413 Request Entity Too Large"), and this
// request holds the proof, the print file and the customer's original upload. Keep the whole upload under
// UPLOAD_BUDGET: the proof and the print file first (the print file made smaller only when it alone is too big), then
// the original file when it still fits. Every change is written in the hidden "_Print file note" property.
var UPLOAD_BUDGET = 18 * 1024 * 1024;
function fmtMB(n) { return (n / 1048576).toFixed(1) + ' MB'; }
function decodeBlob(file) {
  if (window.createImageBitmap) return createImageBitmap(file);
  return new Promise(function (res, rej) {
    var u = URL.createObjectURL(file), im = new Image();
    im.onload = function () { res(im); };
    im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('could not read the print image')); };
    im.src = u;
  });
}
// re-encode a JPEG/PNG smaller (fewer pixels, then lower quality) until it is at most maxBytes
function shrinkImage(file, maxBytes) {
  if (!file || file.size <= maxBytes) return Promise.resolve(file);
  return decodeBlob(file).then(function (bmp) {
    var bw = bmp.naturalWidth || bmp.width, bh = bmp.naturalHeight || bmp.height;
    var scale = Math.min(1, Math.sqrt(maxBytes / file.size) * 0.95), q = 0.9, tries = 0;
    var attempt = function () {
      var w = Math.max(1, Math.round(bw * scale)), h = Math.max(1, Math.round(bh * scale));
      var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
      var ctx = cv.getContext('2d');
      if (!ctx) return Promise.reject(new Error('canvas'));
      ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, w, h);
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(bmp, 0, 0, w, h);
      return new Promise(function (res) { cv.toBlob(res, 'image/jpeg', q); }).then(function (b) {
        cv.width = cv.height = 1;
        if (!b) throw new Error('could not make the print image');
        if (b.size > maxBytes && tries < 5) { tries++; scale *= Math.sqrt(maxBytes / b.size) * 0.95; q = Math.max(0.8, q - 0.03); return attempt(); }
        if (bmp.close) bmp.close();
        return new File([b], String(file.name || 'Ardor Canvas Print Art').replace(/\.[A-Za-z0-9]{1,5}$/, '') + '.jpg', { type: 'image/jpeg' });
      });
    };
    return attempt();
  });
}
// the print file again, as one flattened image (picture, text and clipart, plus the bleed for Image wrap) of at most maxBytes
function smallerPrint(c, maxBytes, approval) {
  var LY = window.ArdorCanvasLayers, P = window.ArdorCanvasPDF, a = ART.front, Wi = c.Wi, Hi = c.Hi;
  var b = c.wrap ? BLEED : 0, PWi = Wi + 2 * b, PHi = Hi + 2 * b;
  if (!LY || !LY.composite || !P || !P.buildPrint) return Promise.reject(new Error('print tools not loaded'));
  var date = (approval && approval.when) || stampLabel(new Date());
  return LY.composite('front', Wi, Hi, a, b).then(function (r) { return shrinkImage(r.file, maxBytes - 65536); }).then(function (file) {
    return P.buildPrint({ title: 'Ardor Canvas Print File', stamp: date, W: PWi / 12, H: PHi / 12, holes: [], dotIn: 0.125,
      faces: [{ art: { file: file, name: file.name, kind: 'image' }, bg: (a && a.bg) || '#FFFFFF', geomFor: function () { return { x: 0, y: 0, w: PWi, h: PHi }; } }] }, false);
  }).then(function (r) { return r && r.blob; });
}
function fitUpload(c, files, approval) {
  var size = function (b) { return b ? b.size : 0; };
  var o = ART.front && ART.front.file ? ART.front.file : null;
  files.skipArt = false; files.needEmail = false;
  var total = function () { return size(files.proof) + size(files.print) + (files.skipArt ? 0 : size(o)); };
  if (total() <= UPLOAD_BUDGET) return Promise.resolve(files);
  var room = UPLOAD_BUDGET - size(files.proof) - 262144;
  var chain = Promise.resolve();
  // 1. the print file alone is too big: make it again as one smaller flattened image
  if (files.print && files.print.size > room && !files.printPng) chain = smallerPrint(c, room, approval).then(function (nb) {
    if (nb && nb.size < files.print.size) {
      files.notes.push('The print file was made at a lower resolution (' + fmtMB(files.print.size) + ' to ' + fmtMB(nb.size) + ') to fit the 20 MB online order upload limit.');
      files.print = nb;
    }
  }, function () { return null; });
  return chain.then(function () {
    // 2. last resort: a print file that still does not fit stays out
    if (files.print && size(files.proof) + files.print.size > UPLOAD_BUDGET) {
      files.notes.push('The print file (' + fmtMB(files.print.size) + ') was too large to attach. Make it from the original artwork.');
      files.print = null;
    }
    // 3. the customer's original file, when it still fits
    if (o && total() > UPLOAD_BUDGET) {
      files.skipArt = true;
      if (!files.print) files.needEmail = true;
      files.notes.push('The customer\'s original file (' + (ART.front.name || 'artwork') + ', ' + fmtMB(o.size) + ') was not attached (over the 20 MB online order upload limit).' + (files.print ? ' The print file has the full design.' : ' The customer was asked to email it.'));
    }
    return files;
  });
}
function addToCart() {
  wrapErr = false;
  showErr('');
  var c = cfg(); var p = price(c);
  if (c.custom && c.problem) { showErr(c.problem); return; } // v3
  if (!p.vid && !c.custom) { showErr(setupMsg()); return; }
  if (!S.delivery) {
    var fs = $('.abb-delivery'); fs.classList.add('is-missing');
    showErr('Choose how you want to get your canvas: pick up in Snohomish or have it shipped.');
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }
  var artLink = window.ArdorArtLink ? window.ArdorArtLink.link(root, ART.front && ART.front.file) : null; // ART0 Oct 19 2026: artwork by link
    if (!ART.front && !hasLayers() && !artLink) { showErr('Upload a photo or artwork first.'); return; }
  var btns = [$('[data-abb-add]'), $('[data-abb-add-m]'), $('[data-abb-add-d]')].filter(Boolean);
  btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
  var done = function () { btns.forEach(function (b) { b.disabled = false; b.textContent = 'Add to cart'; }); };
  var approval = null, emailProof = false, proofEmail = '', cartVid = p.vid; // ART0: proofEmail; v3: cartVid
  var waits = [ART.front].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
  Promise.all(waits).then(function () {
    var wp = wrapProblem(c);
    if (wp) { wrapErr = true; throw new Error(wp); }
    return wallVid(c, p).then(function (vid) { cartVid = vid; }); // v3: custom sizes check out through the price product
  }).then(function () {
    emailProof = needsEmailProof() || !!(artLink && !artLink.loaded); // ART0: a link we couldn't open = emailed proof
    return emailProof ? null : openApproval(c);
  }).then(function (ap) {
    if (ap && ap.emailProof) { proofEmail = ap.email; emailProof = true; ap = null; } // ART0: "Email me the proof to approve"
      approval = ap;
    btns.forEach(function (b) { b.textContent = 'Saving your proof…'; });
    return buildFiles(c, approval).then(function (files) { return fitUpload(c, files, approval); }); // v2: stay under the cart's 20 MB upload limit
  }).then(function (files) {
    var fd = new FormData();
    fd.append('id', String(cartVid));
    fd.append('quantity', String(c.qty));
    if (STYLES_ON.length > 1) fd.append('properties[Style]', c.styleName);
    if (c.kind === 'acrylic') fd.append('properties[Acrylic]', c.acrLabel);
    fd.append('properties[Size]', sizeLabel(c));
    if (!c.custom) fd.append('properties[Orientation]', orientFull(c));
    if (c.framed) fd.append('properties[Frame color]', c.frameName);
    else if (c.printFrame) fd.append('properties[Frame]', c.frameName);
    else if (c.kind === 'acrylic') { fd.append('properties[Drill Holes & Stand off]', c.hwName); fd.append('properties[Round Corners]', c.cornerName); }
    else if (c.kind === 'roll') fd.append('properties[Material]', c.material);
    else fd.append('properties[Edge]', c.edgeName);
    fd.append('properties[Delivery]', deliveryLabel());
    fd.append('properties[Artwork]', artworkLabel());
    var notes = ($('[data-abb-notes]').value || '').trim();
    if (notes) fd.append('properties[Notes]', notes);
    fd.append('properties[Designed in]', 'Ardor Canvas Builder');
        if (artLink) fd.append('properties[Artwork link]', artLink.url); // ART0
        if (proofEmail || (artLink && !artLink.loaded)) fd.append('properties[Proof approval]', 'Email - pending'); // ART0
        if (proofEmail) fd.append('properties[Proof email]', proofEmail); // ART0
    var pl = placementText(ART.front, c); if (pl) fd.append('properties[_Art placement]', pl);
    var added = layerSummary(); if (added) fd.append('properties[_Added in the builder]', added);
    var stampDate = approval && approval.at ? approval.at : new Date();
    var fileStamp = stampFile(stampDate), labelStamp = (approval && approval.when) || stampLabel(stampDate);
    var ext = function (n) { var m = /\.[A-Za-z0-9]{1,5}$/.exec(n || ''); return m ? m[0].toLowerCase() : ''; };
    var pdfFile = function (blob, name) { return new File([blob], name + ' ' + fileStamp + '.pdf', { type: 'application/pdf' }); };
    var MAXPDF = 25 * 1024 * 1024;
    if (files.proof && approval) fd.append('properties[Ardor Canvas Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Canvas Proof'));
    else if (files.proof) fd.append('properties[_Ardor Canvas Unsigned Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Canvas Unsigned Proof'));
    if (!approval) fd.append('properties[Proof]', artLink && !artLink.loaded ? 'Ardor will build the proof from your link and email it to you to approve' : 'We\'ll email you a proof to approve before printing'); // ART0
    if (approval) {
      if (!approval.later) fd.append('properties[Approved by]', approval.name); // DSN: the name comes with the cart signature
      fd.append('properties[Approved on]', approval.when);
      if (!approval.later) fd.append('properties[_Approver email]', approval.email); // DSN: email + phone come from checkout
      if (!approval.later) fd.append('properties[_Approver phone]', approval.phone); else { fd.append('properties[Proof approval]', approval.later); fd.append('properties[_Proof sign]', 'cart'); } // DSN
    }
    var attached = false;
    if (files.print) {
      if (files.print.size <= MAXPDF) { fd.append('properties[_Ardor Canvas Print File - ' + labelStamp + ']', files.printPng ? new File([files.print], 'Ardor Canvas Print File ' + fileStamp + '.png', { type: 'image/png' }) : pdfFile(files.print, 'Ardor Canvas Print File')); attached = true; }
      else files.notes.push('The print file was over 25 MB, so it was not attached. Use the original artwork file.');
    }
    var pnote = [wallNote(c) || (c.framed
      ? 'Floating frame, ' + sizeLabel(c) + ', ' + orientFull(c) + ', frame color ' + c.frameName + ', print at exact size.'
      : 'Canvas ' + sizeLabel(c) + ', ' + orientFull(c) + ', ' + c.edgeName + ', ' + fmt(DEPTH) + ' in deep frame.')];
    if (attached) {
      if (c.custom || c.printFrame) pnote.push('Print file is the exact print size, ' + faceLabel(c) + ' (width x height), no bleed, no marks, 100% scale.' + (files.printPng ? ' PNG with a transparent background.' : '') + (c.holes.length ? ' Holes and stand offs are drilled in production, not printed.' : '') + (c.cornerIn ? ' Round the corners ' + c.cornerName + '.' : ''));
      else if (c.framed) pnote.push('Print file is the exact picture size, ' + faceLabel(c) + ' (width x height), no bleed, no marks, 100% scale.');
      else if (c.wrap) pnote.push('Print file is ' + fmt(files.printW) + ' x ' + fmt(files.printH) + ' in (width x height): the ' + faceLabel(c) + ' face and it includes ' + fmt(BLEED) + ' in bleed on each side. No marks, 100% scale.');
      else pnote.push('Print file is the exact face size, ' + faceLabel(c) + ' (width x height), no bleed, no marks, 100% scale.' + (c.edge === 'mirror' ? ' The sides are a mirror image of the face.' : ' The sides are solid ' + c.edge + '.'));
    }
    files.notes.forEach(function (n) { pnote.push(n); });
    fd.append('properties[_Print file note]', pnote.join(' '));
    if (files.needEmail) fd.append('properties[Artwork file]', 'Too large to upload with the order. Please email it to info@ardorprinting.com.');
      if (ART.front && !files.skipArt) fd.append('properties[Ardor Canvas Artwork - ' + labelStamp + ']', ART.front.file, 'Ardor Canvas Artwork ' + fileStamp + ext(ART.front.name));
    fd.append('properties[_spec]', JSON.stringify({ v: c.size.id, size: c.size.key, w: c.Wi, h: c.Hi, o: c.orient, e: c.edge, st: c.style, f: c.frame, k: c.kind, acr: c.acr, hw: c.hw, cr: c.corner, depth: c.depth, bleed: c.wrap ? BLEED : 0, q: c.qty, u: p.unit }));
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', CONF.cartAddUrl || '/cart/add.js');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 200000) { var pct = Math.round(100 * e.loaded / e.total); btns.forEach(function (b) { b.textContent = pct < 100 ? 'Uploading… ' + pct + '%' : 'Adding…'; }); } };
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) return resolve();
        var msg = xhr.status === 413 ? 'Your files are too big to upload with the order. Please try a smaller file, or request a quote.' : 'We couldn\'t add this to your cart. Please try again, or request a quote.';
        try { var j = JSON.parse(xhr.responseText); if (j && j.description && xhr.status !== 404) msg = j.description; } catch (e) {}
        if (xhr.status === 404 || xhr.status === 422) msg = setupMsg();
        reject(new Error(msg));
      };
      xhr.onerror = function () { reject(new Error('Network error. Please check your connection and try again.')); };
      xhr.send(fd);
    });
  }).then(function () {
    track('ardor_canvas_added_to_cart', { value: p.charged, size: c.size.key, orientation: c.orient, edge: c.edge, style: c.style, frame: c.frame, quantity: c.qty });
    toast(emailProof ? 'Added to your cart. We\'ll email you a proof to approve before we print.' : 'Added to your cart. Your signed proof is saved with your order.');
    window.location.href = CONF.cartUrl || '/cart';
  }).catch(function (err) { if (err && err.cancel) { done(); return; } showErr(err && err.message ? err.message : 'Something went wrong. Please try again.'); done(); updateArtUi(); });
}

// ---------- quote (HubSpot form) ----------
  function summaryText() {
  var c = cfg(); var p = price(c);
  var lines = specLines(c).map(function (l) { return l[0] + ': ' + l[1]; });
  if (ART.front) lines.push('Artwork: ' + ART.front.name + ' (I will send the file)');
  var pl = placementText(ART.front, c); if (pl) lines.push('Placement: ' + pl);
  var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) lines.push('Notes: ' + notes);
  if (S.delivery) lines.push('Delivery: ' + (S.delivery === 'pickup' ? 'Pick up in Snohomish' : 'Ship'));
  lines.push('Online price shown: ' + money(p.charged) + (c.qty > 1 ? ' (' + money(p.unit) + ' each)' : ''));
  return lines.join('\n');
}

function openQuote() {
    var dlg = $('[data-abb-quote-dialog]');
    $('[data-abb-quote-summary]').textContent = summaryText();
    $('[data-abb-quote-ok]').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function copyQuote() {
    var txt = ((cfg().custom || cfg().printFrame) ? 'Wall art' : 'Canvas print') + ' from the Ardor Canvas Builder\n' + summaryText();
    var ok = function () { $('[data-abb-quote-ok]').hidden = false; };
    var fallback = function () {
      var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      var host = $('[data-abb-quote-dialog]') || document.body;
      host.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      host.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, fallback); else fallback();
  }

  // ---------- wiring ----------
  function on(sel, ev, fn) { var el = $(sel); if (el) el.addEventListener(ev, fn); }
  function bind() {
    var qI = $('[data-abb-qty]');
    qI.addEventListener('input', function () { var n = parseInt(qI.value, 10); if (isFinite(n) && n >= 1) { S.qty = Math.min(MAX_QTY, n); render(); } });
    qI.addEventListener('blur', function () { qI.value = String(cfg().qty); });
    on('[data-abb-qty-minus]', 'click', function () { set({ qty: Math.max(1, cfg().qty - 1) }); });
    on('[data-abb-qty-plus]', 'click', function () { set({ qty: Math.min(MAX_QTY, cfg().qty + 1) }); });
    $$('[data-abb-delivery]').forEach(function (r) { r.addEventListener('change', function () { S.delivery = r.value; $('.abb-delivery').classList.remove('is-missing'); showErr(''); }); });
    // v3: custom width and height (acrylic prints and canvas rolls), in inches
    var wI = $('[data-abb-w]'), hI = $('[data-abb-h]');
    var readWH = function () { var w = parseFloat(wI && wI.value), h = parseFloat(hI && hI.value); var nw = isFinite(w) && w > 0 ? Math.round(w * 100) / 100 : S.cw, nh = isFinite(h) && h > 0 ? Math.round(h * 100) / 100 : S.ch; if (nw === S.cw && nh === S.ch) return; S.cw = nw; S.ch = nh; refit(); S.artVer++; render(); };
    [wI, hI].forEach(function (x) { if (!x) return; x.addEventListener('input', readWH); x.addEventListener('change', readWH); x.addEventListener('blur', function () { var c = cfg(); if (c.custom) x.value = fmt(x === wI ? c.Wi : c.Hi); }); });
    on('[data-abb-swap]', 'click', function () { var t = S.cw; S.cw = S.ch; S.ch = t; refit(); set({ artVer: S.artVer + 1 }); });
    
    var fileIn = $('[data-abb-file]');
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; loadFile(f, 'front', true); fileIn.value = ''; });
    var drop = $('[data-abb-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; loadFile(f, 'front', true); });
    // 3D: look at the canvas from the side to see the edge, and back
var sideView = false;
on('[data-abb-flip]', 'click', function () { sideView = !sideView; setText('[data-abb-flip]', sideView ? 'Front view' : 'Side view'); view3d(sideView ? 'right' : 'front'); });
on('[data-abb-zoom-in]', 'click', function () { if (eng) { try { eng.zoom(1); } catch (e) {} } });
    on('[data-abb-zoom-out]', 'click', function () { if (eng) { try { eng.zoom(-1); } catch (e) {} } });
    on('[data-abb-reset]', 'click', function () { sideView = false; setText('[data-abb-flip]', 'Side view'); view3d('home'); });
    on('[data-abb-add]', 'click', addToCart);
    on('[data-abb-add-m]', 'click', addToCart);
    on('[data-abb-add-d]', 'click', addToCart);
    on('[data-abb-quote]', 'click', openQuote);
    on('[data-abb-quote-close]', 'click', function () { var d = $('[data-abb-quote-dialog]'); if (d.close) d.close(); else d.removeAttribute('open'); });
    on('[data-abb-quote-copy]', 'click', copyQuote);
    on('[data-abb-quote-go]', 'click', function () { track('ardor_canvas_quote_request', { value: price(cfg()).charged }); });
    bindLayout();
    bindSig();
    $$('[data-abb-sig-mode]').forEach(function (b) { b.addEventListener('click', function () { setSigMode(b.getAttribute('data-abb-sig-mode')); }); });
    on('[data-abb-sig-text]', 'input', function (e) { $('[data-abb-sig-preview]').textContent = e.target.value; $('[data-abb-sig-type]').classList.remove('is-missing'); });
    on('[data-abb-approve-form]', 'submit', submitApproval);
    on('[data-abb-approve-form]', 'input', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-sig]', 'pointerdown', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-approve-close]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve-back]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve]', 'cancel', function (e) { e.preventDefault(); closeApproval(null); });
  }

  // keep the sticky 3D viewer just below the site's stuck menu bar
  var lastTop = 0;
  function headerOffset() {
    var hd = document.getElementById('SiteHeader') || document.querySelector('.site-header, header[role="banner"]');
    if (!hd) return;
    var pos = getComputedStyle(hd).position;
    if (pos !== 'fixed' && pos !== 'sticky') return;
    var r = hd.getBoundingClientRect();
    if (r.height <= 0 || r.top < -1 || r.top > 1 || r.height > window.innerHeight * 0.4) return;
    var top = Math.round(r.bottom + 16);
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--abb-top', top + 'px'); }
  }
  function watchHeader() {
    var queued = false;
    var run = function () { queued = false; headerOffset(); };
    var queue = function () { if (!queued) { queued = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    headerOffset();
  }

  function init() {
  watchHeader();
  bind();
  render();
  startEngine();
  window.ArdorCanvasBuilder = {
    wall: { styles: STYLES_ON, acrTypes: ACR_TYPES, hws: HWS, corners: CORNERS, psizes: PSIZES, quick: QUICK, unit: wallUnit, problem: wallProblem, holes: acrHoles, pickAcr: pickAcr, pickHw: pickHw, pickCorner: pickCorner, setCustom: setCustom, prices: loadWallPrices, vid: wallVid, from: styleFrom },
    state: S, sizes: SIZES, edges: EDGES, styles: STYLES, frameOn: FRAME_ON, frameSizes: FSIZES, frameColors: FCOLORS, pickStyle: pickStyle, pickFrame: pickFrame, cfg: cfg, price: price, render: render, viewer: function () { return eng; },
    proofCanvas: proofCanvas, files: function (approval) { return buildFiles(cfg(), approval || null); }, wrapProblem: function () { return wrapProblem(cfg()); }, bleed: BLEED, depth: DEPTH, safe: SAFE // v2: numbers for the template PDF
  };
  // used by ardor-canvas-layers.js (text and clipart layers). Sizes are in inches: the face is c.Wi x c.Hi.
  window.ArdorCanvasAPI = {
    cfg: cfg, conf: CONF, state: S, root: root, safe: SAFE, loadFile: loadFile, set: set, render: render, paintFace: paintFace, paintArea: paintArea, toast: toast,
    band: function () { return cfg().margin; },
    getArt: function () { return ART.front; },
    setArt: function (face, a) { ART.front = a || null; S.artVer++; render(); },
    renderArtOnly: function () { S.artVer++; renderArtOnly(); },
    layoutCanvas: function () { return lay.canvas; },
    layoutScale: function () { return lay.scale; },
    editFace: function () { return 'front'; },
    artGeom: function (f, Wi, Hi) { var a = typeof f === 'string' ? ART.front : f, c = cfg(); return a && a.natW > 0 ? geomForArt(a, a.natW, a.natH, Wi || c.Wi, Hi || c.Hi) : null; }
  };
  window.ArdorCanvasBuilder.proof = { noun: 'canvas print', file: 'Ardor Canvas Proof Preview', stamp: stampFile, make: function () { // the PDF button (assets/ardor-proofsheet.js)
var c = cfg(), waits = [ART.front, ART.back].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
return Promise.all(waits).then(function () { return buildFiles(c, null, 'preview'); }).then(function (f) { return f && f.proof; });
} };
try { document.dispatchEvent(new CustomEvent('ardor:canvas-api')); } catch (e) {}
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
